export default {
  bank_product: {
    complete_msg:
      'Wir danken Ihnen von Herzen, dass Sie <span>das Produkt abonniert haben</span>, und wir werden Ihnen ein besseres Produkt zurückzahlen.',
  },
  enter_amount: 'Bitte geben Sie den Betrag ein.',
  reg_complete: 'Registration completed',
  subscription_details: 'Abonnementdetails',
  select_withdrawal_account: 'Wählen Sie das Auszahlungskonto aus',
  email_address: 'E-Mail-Addresse',
  product_info: 'Produktinformation',
  new_amount: 'Neuer Betrag',
  min_running_amount: 'Mindestausführungsbetrag ',
  max_running_amount: 'Maximaler Ausführungsbetrag ',
  product_type: 'Produktart',
  bank_product_name: 'Produktname',
  reg_start_date: 'Startdatum der Registrierung',
  reg_end_date: 'Abonnement-Enddatum ',
  exec_start_date: 'Startdatum der Ausführung ',
  exec_end_date: 'Ausführungsenddatum ',
  basic_info: 'Grundinformation',
  not_applicable: 'Unzutreffend',
  subscription: 'Anmeldung',
  service_prepare: 'Service wird vorbereitet.',
  no_buy_list: 'Es gibt keine Kaufhistorie.',
  no_sell_list: 'Es gibt keine Verkaufsgeschichte.',
  no_list: 'Es gibt keine Liste.',
  locale_name: 'Deutsch',
  Sale_registration: 'Verkaufsregistrierung',
  apply: 'Anwendung',
  status: 'Zustand',
  wallet: 'Brieftasche',
  wallet_address: 'Brieftaschenadresse',
  wallet_transfer: 'Brieftaschenübertragung',
  buy: 'Kaufen',
  sell: 'Verkauf',
  all: 'Alles',
  breakdown: 'Aufschlüsselung',
  act_buy: 'Kaufen',
  act_sell: 'Kaufen',
  asset: 'Aktiva',
  select: 'Auswahl',
  no_select: 'nicht ausgewählt',
  account: 'Konten',
  balance: 'Guthaben',
  login: 'Login',
  logout: 'ausloggen',
  register: 'Registriert als Mitglied',
  select_cancel: 'Deaktivieren Sie die Option',
  cancel: 'annulliert',
  modify: 'Kristall',
  auto_input: '(Automatisch eingegeben)',
  confirm: 'Bestätigung',
  look_up: 'Referenz',
  password: 'Kennwort',
  account_delete: 'Sezession',
  detail: 'mehr',
  list_detail: 'Weitere Informationen',
  birth: 'Geburtstag',
  welcome: 'Willkommen.',
  please_login: 'Bitte Login.',
  confirmation_login: 'Sie können dies überprüfen, wenn Sie sich anmelden.',
  id: 'Benutzername',
  find_id: 'ID suchen',
  find_password: 'Passwort vergessen',
  back: 'Rückkehr',
  agreement: 'Vertragsbedingungen',
  info_input: 'Eingabeinformationen',
  success: 'komplett',
  agree_msg: 'Ich bin damit einverstanden.',
  all_agree: 'Ich bin damit einverstanden, alle',
  agree: 'Zustimmen',
  agreed: 'Einverstanden',
  confirm_password: 'Kennwort bestätigen',
  repeat_password: 'Kennwort bestätigen',
  next: 'Nächster',
  before: 'Geh zurück',
  register_success: 'Jetzt registrieren.',
  verify: 'Bestätigung',
  retention: 'Beibehaltung',
  allow: '(Angenommen)',
  disallow: '(Unacceptable)',
  upload_btn: 'Bitte Drop von Dateien oder klicken Sie hier.',
  continue_entry:
    'Bitte geben Sie Ihre: „[+:verification]“ weiter unten fortzusetzen.',
  login_msg_1: 'Münze bezogenen Konten in COCOFX Versuchen !',
  login_msg_2:
    'Durch unsere COCOFX nutzen Sie bitte das Angebot und Geldbörsen und Dienstleistungen.',
  login_msg_3: 'COCOFX können alle Umgebungen unterstützen.',
  cocofx_register: 'COCOFX Register',
  register_msg_1:
    'Registriert als Mitglied. <br /> Bitte stimmen Sie unseren AGB',
  register_msg_3:
    'Ein COCOFX Konto erhält Zugriff für alle Dienste an der Mühelosigkeit.',
  register_msg_all:
    'Die Zustimmung zu allen beinhaltet die Zustimmung zu erforderlichen und optionalen Elementen, und Sie können die Zustimmung individuell auswählen. Auch wenn Sie sich weigern, den Optionen zuzustimmen, ist der Service verfügbar.',
  register_title: 'Ich bin über dem Alter von 19 Jahren und älter.',
  register_title_2: 'COCOFX Bedingungen',
  register_title_3: 'COCOFX Integration Nutzungsbedingungen',
  register_title_4: 'COCOFX Marketing Hebelwirkung vereinbart',
  register_title_5:
    'Die Erhebung und Verwendung personenbezogener Daten Zustimmung',
  register_title_6:
    'Die Sammlung und Nutzung von Standortinformationen Vereinbarung',
  register_title_7:
    'Ich bin damit einverstanden collect zusätzliche Profilinformationen',
  register_title_8: 'Eingang COCOFX Kontoinformationen',
  register_title_9: 'Eingabeinformationen',
  register_msg_4:
    'Diese Bedingungen gelten für alle Leistungen des Unternehmens zur Verfügung gestellt. <br /> Durch diese Bedingungen zustimmenden, können Sie diese Dienste nutzen, ohne einen separaten Vertrag unterzeichnet.',
  required: '[Erforderlich]',
  option: '[Selektiv]',
  otp_notice: 'Der Zustand wird aktiviert und deaktiviert OTP unmöglich.',
  required_check: 'Bitte überprüfen Sie alle erforderlichen Felder aus',
  check_input: 'Bitte geben Sie alle Details.',
  register_guide: 'Wie zu verwenden COCOFX',
  register_step1: 'Klicken Sie COCOBANK-Taste',
  register_step2: 'Login für die COCOBANK',
  register_step3: 'Pay / Nachladen COCOBANK Anmelden',
  copy: 'Kopieren',
  no_account: 'Es gibt keine registrierten Konten.',
  inviter_link: 'Verweisende Links',
  register_used_account: 'Registrieren Sie häufig verwendete Konten',
  security_certification: 'Sicherheitszertifizierung',
  admin_security: 'Die Sicherheitsstufe für {action} ist {limit}.',
  company: 'Unternehmen',
  exact_calculation: 'Einstellung',
  profile: 'Mitglieds informationen',
  inquiry: 'Anfrage',
  announcement: 'Benachrichtigungen',
  information: 'Information',
  history: 'Geschichte',
  registration_date: 'Registrierungsdatum',
  pay: 'Zahlung',
  detail_search: 'Volltextsuche',
  more_view: 'Mehr sehen',
  exchange_store: 'Austausch',
  external_exchange_store: 'Externer Austausch',
  internal_exchange_store: 'Interner Austausch',
  external_transaction: 'Externe Transaktion',
  internal_transaction: 'Interne Transaktion',
  favorites: 'Favoriten',
  no_favorite_list: 'Es gibt keine Favoritenhistorie.',
  no_alias: 'Kein Alias',
  please_enter_account_name: 'Bitte geben Sie Ihren Kontonamen ein.',
  variable_amount: 'Variable Menge',
  changes: 'Änderungen',
  account_transaction_history_inquiry: 'Anfrage zur Kontotransaktionshistorie',
  exchange_application_completed:
    'Der Antrag auf Geldwechsel wurde abgeschlossen.',
  choose_how_pay_fee: 'Wählen Sie, wie die Gebühr bezahlt werden soll',
  free: 'frei',
  closing: 'Schließen',
  relative_asset_inquiry: 'Relative Vermögensabfrage',
  please_enter_relative_account_number:
    'Bitte geben Sie die relative Kontonummer ein.',
  Please_enter_relative_wallet_address:
    'Bitte geben Sie die relative Brieftaschenadresse ein.',
  memo: 'Memo',
  write_history_memo:
    'Es ist bequem zu verwalten, wenn Sie Verlaufsnotizen aufschreiben.',
  re_enter: 'Erneut eingeben',
  transfer_wallet_account: 'Brieftaschenadresse übertragen',
  transfer_wallet_inquiry: 'Brieftaschenanfrage übertragen',
  Kiosk: 'Kiosk',
  withdrawable_amount: 'Auszahlbarer Betrag',
  transferred_assets: 'Vermögenswerte übertragen',
  recipient: 'Empfänger',
  recipient_wallet: 'Empfänger Brieftasche',
  register_user_name_tit:
    'Wir empfehlen, dass Sie den richtigen Namen für die Sicherheitszertifizierung ausfüllen.',
  register_password_tit:
    'Bitte füllen Sie die häufig verwendete E-Mail-Adresse korrekt aus.',
  product_name: 'Produktname',
  dividend_type: 'Dividendenart',
  auto: 'Automatisch',
  manual: 'Handbuch',
  s_usdt_protocol: 'Wählen Sie ein TETHER-Protokoll aus',
  ccf: {
    what_ccf: 'Was ist CCF?',
    key_coin:
      'Die Schlüsselmünze der COCOBANK, die Kryptowährung mit realer Währung verbindet',
    ccf_description:
      'Es ist die Schlüsselmünze der CocoBank, die verschiedene Kryptowährungen durch direkten Umtausch und C2C-Transaktionen umwandelt. 1CCF hat einen Wert von USD 1CENT. CCF ermöglicht schnellere und sicherere Käufe und Transaktionen mit COCOFX.',
    how_use_ccf: 'Wie benutzt man CCF?',
    cocobank_wallet_transfer:
      'Übertragen Sie Kryptowährungs-Assets, die an externen Börsen gespeichert sind, in die Brieftasche der COCOBANK.',
    ccf_conversion:
      'Konvertieren Sie die in die Brieftasche übertragene Kryptowährung durch direkten Geldwechsel oder C2C-Transaktion in CCF.',
    direct_exchange_c2c_deal: 'C2C-Transaktion mit direktem Geldwechsel',
    ccf_moved: 'Der konvertierte CCF wird auf Ihr COCOBANK-Konto überwiesen.',
    how_use_account_ccf:
      'CCF, das auf Ihr Konto übertragen wurde, wird so verwendet!',
    freely_purchase_open_market:
      'Kaufen Sie mit CCF kostenlos Open Market-Produkte!',
    free_deposit_withdrawal:
      'Kostenlose Ein- und Auszahlung sowie Überweisung zwischen Konten innerhalb der Bank!',
    exchange_currencies_convenient:
      'Der Umtausch zwischen Währungen wird durch direkten Geldwechsel und C2C-Transaktionen bequem!',
    offline_convenient:
      'Nutzen Sie die Dienste der COCOBANK bequemer, auch offline!',
    how_wallets_accounts_different:
      'Wie unterscheiden sich Brieftaschen und Konten?',
    same_means_storing_cryptocurrency:
      'In der CocoBank sind Brieftaschen und Konten das gleiche Mittel zum Speichern der Kryptowährung, ihre Verwendung hängt jedoch vom Transaktionstyp (intern und extern) der Kryptowährung ab. Mit anderen Worten, die Brieftasche wird für Transaktionen (extern) zwischen der Börse und der COCOBANK verwendet, und das Konto wird für Transaktionen (intern) in der COCOBANK verwendet.',
  },
  header: {
    certification_management: 'Zertifizierung / Management',
    c2c_enroll: 'Kauf / Verkauf',
    wallet_list: 'Wallet / History &',
    wallet: 'Brieftasche',
    c2c_list: 'Kauf / Verkaufshistorie',
    no_c2c_sell_list: 'Es gibt keine Verkaufshistorie.',
    transfer_list: 'Wechselkurs Geschichte',
    no_transfer_list: 'Es gibt keinen Austausch der Geschichte.',
    withdrawal_list: 'Input / Rücknahme Geschichte',
    my_info: 'Meine Informationen',
    home: 'Maine',
    payment_history: 'Billing Geschichte',
    account_transfer: 'Account Transfer',
    transfer_history: 'Transferhistorie',
    register_used_account: 'Registrieren Sie häufig verwendete Konten',
    exchange: 'Zum Austausch',
    exchange_list: 'Wechselkurs Geschichte',
    email: 'E-Mail',
    email_list: 'E-Mail-Geschichte',
    otp: 'OTP',
    otp_list: 'OTP Geschichte',
    register_account: 'Registrierung Konto',
    calculation_account_list: 'Verrechnungskonten Liste',
    security_certification: 'Sicherheitszertifizierung',
    history: 'Geschichte',
    coco_open_market: 'COCO Open Market',
    information: 'Information',
    my_profile: 'Meine Informationen',
    email_modify: 'Bearbeiten E-Mail',
    password_modify: 'Bearbeiten Sie Ihr Passwort',
    inquiry: 'Anfrage',
    inquiry_history: 'Kontaktdetails',
    one_on_one_inquiry: '1:1 Anfrage',
    frequently_asked_questions: 'FAQ',
    announcement: 'Benachrichtigungen',
    notice: 'Benachrichtigungen',
    server_notice: 'Server Ankündigungen',
    service_center: 'Service Zentrum',
    profile: 'Mitglieds Informationen',
    company: 'Unternehmen',
    exact_calculation: 'Einstellung',
    account_management: 'Account Management',
    do_exchange: 'Zum Austausch',
    transfer: 'Transfers',
    look_up: 'Referenz',
    faq: 'FAQ',
    server: 'Server',
    email_request: 'E-Mail-Kontakt',
    Product_Subscription: 'Produkt & Abonnement',
    easy_payment: 'Einfache Bezahlung',
    easy_login: 'Einfache Anmeldung',
  },
  footer: {
    footer_msg: 'Nutzen Sie die Münze bezogenen Konten in COCOFX!',
    footer_sub_msg:
      'Durch unsere COCOFX bitte die Brieftasche Transaktionen und Dienste nutzen',
    footer_sub_msg2: 'Spitze',
    footer_sub_msg3: 'COCOFX können alle Umgebungen unterstützen.',
    ICO: 'ICO',
    c2c: 'C2C Austausch',
    b2c: 'B2C Börsen',
    margin_exchange: 'Kursspanne',
    gift_exchange: 'Futures Exchange',
    Binary: 'binäre Optionen',
    open_marcket: 'Open Market',
    game: 'Spiele',
    proceed: 'laufende Transaktionen',
    public: 'IPO-Nachrichten',
    direct_ex: 'Direkter Austausch',
    buy: 'Kaufen',
    sell: 'Kaufen',
    buy_sell: 'Kaufen / Verkaufen',
    holding_coin: 'Halten Münze',
    fee: 'Fee-Führer',
    exchange: 'Austausch',
    transfer_record: 'Handelsgeschichte',
    Leverage: 'Hebelwirkung',
    live_exchange: 'Live-Trading',
    demo_exchange: 'Demo Handel',
    contest: 'Rallye',
    powerball: 'Powerball',
    law:
      'Legal: COCOFX.COM Registriernummer: 70638826927 (U 6 29 Railway Pde EastwoodNSW 2122)',
    law1:
      'Handelspunkt von Finanzinstrumenten Der Eigentümer der gesamten Ltd (Australien) ist COCOFX PTY Ltd Registernummer: 70638826927 Marke.',
    law2:
      'Diese Website wird von COCOFX Corp. angetrieben COCOFX Corp genehmigt Nummer 64190 - ist im Rahmen der Regelung der Hilfsfinanzdienstleistung, wird es in der Referenznummer 70638826927 Australien registriert.',
    law3:
      'COCOFX arbeitet nach den australischen Finanzprodukte Anlagerichtlinien.',
    law4:
      'ref. Nr. 538.324 | ABN reg. 70638826927 | BA reg. 64190. Um sicherzustellen, dass Sie ist die alleinige Verantwortung des Kunden dürfen COCOFX Dienstleistungen in den Rechtsvorschriften des Aufenthaltsland nutzen.',
    law5: 'Bitte lesen Sie die Risikooffenlegung professionelle COCOFX.',
    law6:
      'COCOFX bietet keine Dienstleistungen für die Vereinigten Staaten, Belize, Mauritius, Japan, Alberta, British Columbia, Quebec, Saskatchewan Bewohner von Saskatchewan, Haiti, Surinam, Nordkorea, Puerto Rico und den besetzten Gebieten Zyperns.',
    law7:
      'Bitte beachten Sie den regulatorischen Teil der FAQ für weitere Informationen. Bitte beachten Sie unsere Risikooffenlegung.',
    law8:
      'Sperrgebiete: Trading Point of Financial Instruments Ltd bietet keine Anlage- und Nebendienstleistungen für Dritte Welt Ländern und Regionen.',
    law_warn: 'Risikohinweis:',
    law_1:
      'CFD hat ein hohes Risiko und komplexe Produkte ihr Geld schnell durch Hebelwirkung verlieren. 69,10% der einzelnen Anleger Account Geld verlieren, wenn Sie den CFD-Handel.',
    law_2:
      'Sie müssen prüfen, ob Sie die Tatsache akzeptieren, dass Sie die CFD funktioniert verstehen, desto höher ist das Risiko, Geld zu verlieren. Bitte beachten Sie unsere Risikooffenlegung.',
    alert_title: 'Hinweis und Hinweis',
    coco_market: 'COCO Markt',
    ieo_market: 'IEO Markt',
    news: 'Nachrichten',
    event: 'Veranstaltung',
    platform_rental_title: 'Bühnenverleih',
    education: 'Bildung',
    online_Academy: 'Online Academy',
    offline_Academy: 'offline-Akademie',
    shopping_basket: 'Einkaufskorb',
    best_product: 'Beste Angebote',
    order: 'Auftrag',
    my_page_title: 'meine Seite',
    member_info_management: 'Account Management',
    order_management: 'Auftragsverwaltung',
    my_question: 'meine Frage',
    one_enquiry: '01.01 Uhr Kontakt',
    community: 'Gemeinschaft',
    lotto: 'Powerball-Lotterie',
    rock_event: 'Rock Event',
    quiz_game: 'Trivia Game',
    ladder_game: 'Leiter',
    tetris: 'Tetris',
    split_lotto: 'Geteilte Lotto',
    day_Lottery: 'täglich Lotterie',
    attendance: 'Anwesenheitskontrolle',
    scoop_out: 'Einbetten',
    forum: 'Forum',
  },
  main_msg: {
    about_1_title: 'Die besten Passwörter Devisenhandel Dienstleistungen Welt',
    about_1_msg:
      'Alle Dienstleistungen im Zusammenhang mit der Münze führenden COCOFX.',
    about_1_1_msg:
      'Erhältlich zum ersten Mal Umsatz Kryptowährung Münze in einem Ort in der Welt.',
    about_1_2_msg:
      'Wie für den direkten Austausch ist es bei COCOBANK zur Verfügung.',
    about_2_title: 'Unmittelbar Austauschsystem',
    about_2_msg:
      'COCOFX Verwendung einer stabilen Mehr parallel Matching-Technologie Unmittelbar Anwendung der erweiterten Design-Technologien Austausch zu ermöglichen, Stock Exchange-System.',
    about_3_title: 'Wallet erzeugt',
    about_3_msg:
      'Sicherheitsexperten wurden COCOFX setzt sich aus den besten Ingenieure in Korea Ausgestattet mit state-of-the-art Sicherheitssystem bietet WALLTE System.',
    about_4_title: 'Einfache Handelssysteme (C2C)',
    about_4_msg:
      'COCOFX ist ein einfaches, benutzerfreundliche Handelssystem aufbauen Lassen Sie uns eine bequemere Transaktion ermöglichen.',
    c2c_main_msg1_1:
      'COCOFX sofort zuverlässige Multi parallel Matching-Technologie auszutauschen mit',
    c2c_main_msg1_2:
      'Halten Sie das Austauschsystem, das die erweiterten Designtechniken Anwendung zu ermöglichen und',
    c2c_main_msg1_3: 'Es gibt.',
    c2c_main_msg2_1:
      'Sicherheitsexperten wurden COCOFX setzt sich aus den besten Ingenieure in Korea',
    c2c_main_msg2_2:
      'Ausgestattet mit state-of-the-art Sicherheitssystem bietet Wallet-System.',
    c2c_main_msg3_1:
      'COCOFX ist leichter zu bauen benutzerfreundliche Handelssystem',
    c2c_main_msg3_2: 'Es ermöglicht einen einfachen Handel.',
  },
  toasted_msg: {
    agree_required_term:
      'Bitte stimmen Sie den erforderlichen Geschäftsbedingungen zu',
    must_read_term:
      'Sie müssen alle Allgemeinen Geschäftsbedingungen lesen oder herunterladen.',
    confirm: 'Es wurde festgestellt',
    changed: 'Änderungen wurden',
    withdrawal: 'Der Entzug war',
    register: 'Es wurde registriert.',
    delete: 'Es wurde gelöscht.',
    title: 'Benachrichtigungen',
    exchange: 'Direkter Austausch wurde erfolgreich verarbeitet.',
    search: 'Es wurde betrachtet.',
    deposit_request: 'Anwendung hinterlegt wurde.',
    withdraw_request: 'Rückzug wurde die Anwendung.',
    create_account: 'Es wurde geöffnet.',
    modify: 'Es wurde behoben.',
    cancel: 'Es wurde gelöscht.',
    trade_confirm: 'Handel wurde eingerichtet.',
    trade_reject: 'Deal verweigert.',
    copy: 'Kopiert.',
    nice_msg:
      'Wenn Sie in Ihren Browser-Einstellungen nicht deaktiviert werden Pop-up-Identitätsauthentifizierung geht nicht normal.',
    nice_title: 'Information',
    nice_success: 'Identitätsauthentifizierung wurde erfolgreich verarbeitet.',
    nice_error: 'Kann Ihre Identität überprüfen.',
    no_transfer: 'Keine Informationen auszutauschen.',
    email_auth: 'E-Mail-Authentifizierung erfolgreich abgeschlossen.',
    email_auth_send: 'Diese E-Mail wurde zur Zertifizierung geschickt.',
    kyc_withdraw: 'Konto-Authentifizierung erfolgreich war.',
    not_allow_trade: 'Deal ist inaktiv.',
    id_find_mail_send: 'ID wurde per E-Mail zugeschickt.',
    duplicate_check: 'Doppelte ID oder E-Mail.',
    pay: 'Die Zahlung ist abgeschlossen.',
  },
  private: {
    deal_list: 'Vertrieb Geschichte',
    app_list: 'Bisherige Einkäufe',
    deal_buy_asset: 'Vermögenswerte zu kaufen',
    buy_price: 'Kaufpreis',
    confirmed_source_amount: 'Bestätigen Vertrieb',
    holding_source_amount: 'Unbestätigten Vertrieb',
    potential_source_amount: 'Verfügbare Menge',
    direct_market: 'Direkter Austausch',
    deal_enroll: 'Verkaufen',
    app_enroll: 'Zum Kauf',
    select_market: 'Select Market',
    fee_rate: 'Kommission',
    deal_info_input: 'Geben Sie Sales Information',
    deal_source_amount: 'Vertrieb',
    deal_price: 'Preis pro Einheit',
    deal_enroll_account: 'Konto für Verkauf',
    account_select: 'Wählen Sie Konto',
    direct_asset_select: 'Bitte wählen Sie einen An- und Verkauf',
    please_select_asset: 'Bitte wählen Sie einen Vermögenswert aus.',
    basic_rate: 'aktuelle Preis',
    direct_transfer_buy: 'sofortiger Kauf',
    direct_transfer_sell: 'Unmittelbar zum Zeitpunkt des Verkaufs',
    direct_source_amount: 'Währungswechseleinheit',
    direct_target_amount: 'Apply Menge',
    direct_asset_buy: 'Kaufen {0}',
    direct_asset_sell: 'Die Verkäufe an {0}',
    selected_deal_info: 'Ausgewählte Vertriebsinformations',
    deal_source_asset_title: 'Vermögenswerte gekauft',
    deal_total_source_amount: 'Gesamtumsatz',
    app_info_input: 'Geben Sie Informationen zum Kauf',
    app_amount: 'Kaufvolumen',
    app_deal_price: 'bewertet',
    pay_target_amount: 'Menge bezahlt zu tun',
    fee: 'Kommission',
    fee_calc: 'Gebührenbetrag',
    msg_fee_calc: 'Als {0} abgezogen.',
    app_account: 'Konto für Kauf',
    app_receive_account: 'Wählen Sie Konto zu erhalten',
    c2c_buy_select_asset: 'Bitte wählen Sie einen Kauf',
    go_home: 'Zurück zur',
    buy_calc_spread: 'Kaufen Währung',
    sell_calc_spread: 'Verkaufen Währung',
    cs_market_asset: 'Assets Paar',
    cs_market_basic_rate: 'Marketing-Referenzkurs',
    transfer_type: 'Exchange-Typ',
    exchange_rate: 'Wechselkurs',
    submit_transfer: 'Ab sofort austauschen',
    deal_source_min_amount: 'Die Mindestabnahmemenge',
    closed_date: 'Terminate ein',
    no_deal: 'Keine Verkaufsliste',
    app_price_per_quantity: 'Preis pro Einheit',
    app_fee_amount: 'Gesamtkosten',
    select_deal_app_list: 'Käufe von ausgewähltem Vertrieb',
    no_select_deal_app_list: 'Keine Einkäufe in seinem Umsatz',
    transfer_source_amount: 'Basierend auf der Aktivmenge',
    transfer_target_amount: 'Für Vermögenswerte Menge',
    transfer_basic_rate: 'Referenzzinssatz anzuwenden Verkauf',
    transfer_spread_rate: 'Ausbringmenge Spreads',
    transfer_exchange_rate: 'Wechselkurs',
    transfer_list_detail: 'Austausch anfordern Mehr Informationen',
    transfer_source_asset: 'Auf der Grundlage von Vermögenswerten',
    transfer_target_asset: 'für Vermögenswerte',
    transfer_source_account_number: 'Basierend auf der Asset-Kontonummer',
    transfer_target_account_number: 'Für Asset-Kontonummer',
    transfer_detail_type: 'Exchange-Typ',
    transfer_regdate: 'Tragen Sie eine',
    transfer_asset_info: '{0} bis {1} {2}',
    transfer_asset_select: 'Bitte wählen Sie das Asset ersetzen möchten.',
    msg_transfer_buy: 'Kaufen {0}',
    msg_transfer_sell: 'Die Verkäufe an {0}',
    deal_fee_amount: 'Verkauf Disclosure Partei erhobene Gebühren',
  },
  wallet_page: {
    have_asset: 'Aktiva',
    asset_list: 'Liste der Assets',
    account_list: 'Kontoliste',
    account_create: 'Kontoerstellung',
    deposit: 'Anzahlung',
    withdraw: 'Rückzug',
    deposit_list_look: 'Kaution Lookup',
    deposit_look: 'Kaution Ansichten',
    withdraw_list_look: 'Rückzug Geschichte &',
    withdraw_look: 'Rückzug Ansichten',
    account_modify: 'Konto ändern',
    deposit_apply: 'Kaution Anwendung',
    withdraw_apply: 'Anmeldung zurückgenommen',
    deposit_request_amount: 'Einzahlungsbetrag',
    withdraw_request_amount: 'Auszahlungsbetrag',
    withdraw_account_info: 'Rücktritt Kontoinformationen',
    holder_name: 'Name des Kontoinhabers',
    bank_name: 'Name der Bank',
    withdraw_bank_address: 'Kontonummer',
    withdraw_address: 'Immobilien-Adresse',
    qr_address: 'Kontoadresse',
    create_qr_address: 'Kontoeröffnung Adresse',
    account_enroll: 'Kontoregistrierung',
    account_seq: 'Konto-ID-Nummer',
    account_title: 'Kontoname',
    regdate: 'Gaeseolil',
    before_regdate: '(Vor dem Öffnen)',
    holding_balance: 'Stoppen Sie den Betrag',
    select_asset: 'Wählen Sie Eigenschaft',
    create: 'geöffnet',
    deposit_list: 'Anzahlung',
    no_deposit_list: 'Es gibt keine Angaben zum Einzahlungsantrag.',
    deposit_apply_detail: 'Kaution anfordern Mehr Informationen',
    asset_title: 'Vermögenswert',
    request_amount: 'Offener Betrag',
    withdraw_list: 'Rückzug Geschichte',
    no_withdraw_list: 'Es gibt keine Auszahlungsanforderung.',
    withdraw_apply_detail: 'Rückzug anfordern Mehr Informationen',
    withdraw_fee_total_amount: 'Total Auszahlung (inklusive Gebühren)',
    net_amount: 'Endbetrag',
    fee_type: 'fee type',
    fee_charge_type: 'Fee charge type',
    amount_of_fee: 'Amount of fee',
    create_account_address: 'Kontoeröffnung Adresse',
    deposit_msg:
      'Deponiert mein Portemonnaie {0} {0} von der Außenseite der Brieftasche.',
    deposit_msg_1:
      'Nach der Genehmigung 350 mal (Bestätigung) auf der Blockkette {0} Transaktionen werden in der Brieftasche reflektiert.',
    deposit_step_1: 'Schritt 1 zuerst die ID {0} Notizen prüfen.',
    deposit_step_1_1: 'Meine Notizen ID {0}',
    deposit_step_1_2:
      '{0} muss eigene Notizen ID markieren, wenn Sie einzahlen. {0}, ohne Transfer Notizen ID verloren.',
    deposit_step_1_3: 'Sehen Sie Ihre {0} Wallet-Adresse.',
    deposit_step_1_btn: 'Notes-ID-Kopie',
    deposit_step_2: 'Schritt 2. Ihr Portemonnaie Adresse überprüfen.',
    deposit_step_2_1: 'QR Code',
    deposit_step_2_2: 'Wallet-Adresse',
    deposit_step_2_3:
      'Der Mindesteinzahlungsbetrag ist <span style = "color: # 4a90e2"> {0} {1} ist </ span>.',
    deposit_step_2_btn: 'Purse Adresse kopieren',
    deposit_msg_2: 'Bitte überprüfen',
    deposit_msg_2_1: 'Diese Adresse ist die Adresse für die Hinterlegung nur.',
    deposit_msg_2_2:
      'Die gesamte Zeit, die Fertigstellung entsprechen kann durch die Überlastung der Blockkette Netzwerk beeinflusst werden, Kryptowährung Sterne Block Chaining Staus <span style ="color: #4a90e2; cursor: pointer;"> hier </span> Sie können überprüfen.',
    no_account_list: 'Es gibt keine Kontoliste.',
    no_favorite_account_list: 'Es gibt keine Liste der bevorzugten Konten.',
    input_account: 'Bitte geben Sie Ihren Kontonamen an, um zu ändern.',
  },
  my_page: {
    profile: 'Mitgliedsinformationen',
    user_unique_num: 'Mitgliedsidentifikationsnummer',
    user_name: 'Benutzername',
    email_address: 'E-Mail',
    register_regdate: 'seit',
    last_login: 'Letzte Anmeldung',
    auth_complete: 'bescheinigt',
    not_auth: 'Uncertified',
    expdate: 'Ablauf',
    act_auth: 'authentifizieren',
    realname_auth: 'Identitätsauthentifizierung',
    email_auth: 'E-Mail-Authentifizierung',
    otp_auth: 'OTP-Authentifizierung',
    enroll: 'Anmeldung',
    security: 'Sicherheitsstufe',
    show_security: 'Siehe Sicherheitsstufe',
    auth_withdraw_address: 'Rückzug Adressauthentifizierung',
    apply_list: 'Bewerbungsverlauf',
    password_modify: 'Bearbeiten Sie Ihr Passwort',
    email_modify: 'Bearbeiten E-Mail',
    account_block: 'Rückzug Konto',
    placeholder_old_password: 'Bitte geben Sie Ihr altes Passwort ein',
    placeholder_new_password: 'Bitte geben Sie Ihr neues Passwort',
    placeholder_confirm: 'Bitte geben Sie erneut',
    placeholder_password: 'Bitte geben Sie Ihr Passwort',
    placeholder_email: 'Geben Sie eine neue E-Mail',
    mail_cert_list: 'E-Mail-Anwendung Geschichte',
    no_mail_list: 'Keine E-Mail-Anwendung Geschichte.',
    nominee_detail: 'Phidikularkreisgeschichte.',
  },
  kyc: {
    register_account: 'Registrierung Konto',
    kyc_enroll: 'KYC Authentication Anwendungen',
    kyc_enroll_2: 'KYC Nachweis der Adresse',
    kyc_enroll_3: 'KYC Grund für die Anpassung in 4 Schritten nach oben',
    auth: 'Bescheinigung',
    auth_code_send: 'Senden der Authentifizierungscode',
    auth_code: 'Authentication Code',
    msg_auth_code:
      'Bitte geben Sie den Bestätigungscode innerhalb von 5 Minuten.',
    type_title: 'Name des Typs',
    withdraw_auth: 'Rückzug Adressauthentifizierung',
    withdraw_auth_tit:
      'Ein objektives Adressen-Authentifizierungsverfahren für den externen Abzug. Bitte registrieren Sie das Zielkonto und die Wallet-Adresse, die erworben werden soll.',
    select_asset: 'Wählen Sie Eigenschaft',
    select_bank: 'Select Bank',
    holder_name: 'Name des Kontoinhabers',
    birth: '6-stellige Geburtsdatum',
    address: 'Immobilien-Adresse',
    withdraw_list: 'Rücktritt Kontoantrag Geschichte',
    bank_name: 'Name der Bank',
    withdraw_info: 'Rücktritt Kontoinformationen',
    withdraw_complete:
      'Die Liegenschaft abgeschlossen bereits diese Zertifizierung.',
    regdate: 'zusätzlich',
    delete_withdraw_address: 'Veränderte Debit Adresse',
    delete_success_address: 'Der Rückzug Adresse hat sich geändert.',
    kyc_cert_list: 'KYC Anwendungsgeschichte',
    no_kyc_list: 'KYC ist keine Anwendung Geschichte.',
    no_kyc_withdraw_address_list:
      'Es gibt keine Zahlungskonto Anwendung Geschichte.',
    kyc_placeholder: 'Bitte kommen Sie herein.',
  },
  otp: {
    enter_verification_number: 'Geben Sie eine OTP-Authentifizierung Nummer',
    otp_auth: 'OTP-Authentifizierung',
    authenticode: 'OTP Keys',
    otp_deactivate: 'OTP Behinderte',
    msg_authenticator_installation:
      'Die „Google Authenticator“ App installieren Sie auf Ihrem Smartphone oder auf dem Desktop',
    android: 'androide',
    or: 'oder',
    iphone_series: 'iPhone, iPad und iPod',
    windows_phone: 'Windows Phone',
    and: 'und',
    msg_microsoft_other_systems:
      'Andere Systeme, einschließlich Microsoft Windows-Desktop',
    msg_key: 'der Schlüssel',
    msg_use_loss_change:
      'Bitte schreiben Sie auf dem Papier. Verlorene oder Terminal verwendet wird, wenn Sie die OTP ändern müssen.',
    msg_brcode_touch:
      'Führen Sie die "Google Authenticator" app Preisinformationen bitte Tippen auf die <b> Scan QR Barcode </ b> am unteren Rand des Bildschirms.',
    msg_input_authenticode:
      'Bitte geben Sie den Bestätigungscode auf dem Terminalbildschirm im „Authentication Code“ unten angezeigt.',
    otp_key: 'OTP Keys',
    otp_activate: 'OTP-Aktivierung',
    otp_copy: 'Die OTP Schlüssel kopiert.',
    otp_safe_keeping:
      'Weniger als hätte die OTP-Taste auf dem Papier und bewahren Sie sie an einem sicheren Ort?',
    yes: 'vier',
    otp_register: 'Einschreibung',
    otp_register_success:
      'Die OTP-Registrierung wurde erfolgreich abgeschlossen.',
    otp_delete_success:
      'OTP Löschung der Eintragung erfolgreich abgeschlossen.',
    msg_click_key_copy: 'Klicken Sie auf den kopierten Schlüssel.',
    otp_login: 'Login OTP',
  },
  security: {
    show_security: 'Siehe Sicherheitsstufe',
    grade: 'Wertung',
    condition: 'Zustand',
    restriction: 'Begrenztheit',
    no_grade: 'Mudeunggeup',
    no: 'jeder',
    security_title: 'Einschränkungen spezifische Sicherheits Rating-Kriterien',
    banner1: 'Trusted Sicherheit',
    banner2:
      'Für den Kauf oder Verkauf durch COCOBANK, COCOBANK Datenverschlüsselung zu sichern, Echtzeit-Überwachung von Transaktionen, die Käufer und Verkäufer Schutzpolitik, und alle Ihre Zahlungen über eine sichere Kasse und Prämienregelung für COCOBANK.',
    banner_invite: 'COCOBANK Sie haben noch keine Zugangsdaten?',
    banner_join: 'Kostenlos Registrieren',
    banner3: 'Wie COCOBANK hält unsere Kunden sicher',
    content1_h3: 'Käuferschutz',
    content1_text:
      'Wenn die Abnutzung oder Beschädigung mibaesong ohbaesong Käufer, COCOBANK kann für den Gesamtzahlungsbetrag zu kompensieren, einschließlich den Kosten für in Frage kommende Transaktionen Versand. *',
    content2_h3: 'Verkäuferschutz',
    content2_text:
      'Wenn Sie eine nicht autorisierte Zahlung oder mibaesong Ansprüche gegen den Verkäufer in dem Verkauf sind berechtigt, erhalten, können Sie den vollen Betrag des Schutzes erhalten. *',
    content3_h3: 'Datenverschlüsselung',
    content3_text:
      'TLS, HTTPS-Verbindungen zu helfen, die Zahlung, der Schlüssel von mobilen Anwendungen Pinning, PCI-Compliance sicherer.',
    content3_btn: 'PCI Compliance',
    content4_h3: 'Fraud Prevention',
    content4_text:
      'Alle Transaktionen werden in Echtzeit überwacht von Ihrem Konto und Unterstützung der Analyse betrügerische Aktivitäten und Abrechnung zu verhindern.',
    sec_h2: 'Scheck Kaufen',
    sec_text:
      'COCOBANK, da die Transaktion Überwachung 24 Stunden am Tag, 365 Tage, wenn es etwas anders als sonst erkennt den Käufer zu kontaktieren fragen Sie Ihre Anmeldung oder Kauf zu bestätigen. Auch COCOBANK Prüfungen für alle Käufe und Verkäufe via E-Mail.',
    wran_h2: 'Wenn Sie einen verdächtigen Punkte',
    warn_step1: 'Bericht.',
    warn_step1_text1:
      'Nachdem Sie die Details bestätigen gefunden haben kein Abkommen genehmigt',
    warn_step1_text2: 'Problem melden> nicht autorisierte Aktivitäten Bericht',
    warn_step1_text3: 'Klicken Sie oder kontaktieren Sie sofort COCOBANK.',
    warn_step2: 'Überprüfen Sie, ob es andere Probleme gibt.',
    warn_step2_text1:
      'Überprüfen Sie den letzten Handelsaktivitäten und Kontoeinstellungen, um sicherzustellen, dass die zusätzlichen Kosten oder Änderungen, bitte diese Informationen auch melden.',
    warn_step3: 'Bitte ändern Sie Ihr Passwort ein.',
    warn_step3_text1:
      'Sie können in den Kontoeinstellungen auf dem Menü Sicherheit. Oder, wenn Sie sind nicht in der Lage sich in Ihrem Konto anmelden',
    warn_step3_text2: 'Login> Probleme mit dem Login',
    warn_step3_text3: 'Klicken Sie auf Reset zu erhalten.',
    warn_btn: 'Melden Sie nicht autorisierte Transaktionen',
    online_h2: 'COCOBANK unterstützt Online-Aktivitäten sichern.',
    online_h3: 'Kontosicherheit',
    online_text: 'Schützen Sie Ihr Konto mit einem sehr sicheren Passwort.',
    online_btn: 'Erfahren Sie mehr',
    auth_incomplete: 'Zertifiziert unvollständig',
  },
  input: {
    id: 'Eingang ID',
    password: 'Geben Sie ein Passwort ein (8-32 Ziffern mit Sonderzeichen)',
    repeat_password: 'Kennwort bestätigen',
    user_name: 'Eingang Benutzername',
    email_address: 'Eingang E-Mail-Adresse',
  },
  oauth: {
    contact_msg:
      'Will den Zugriff auf die folgenden Informationen in der Anwendung {0}.',
    agree_msg:
      '{0} Stimmen Sie zu, dass der Zugriff auf {1} ‚s persönliche Daten?',
    agree_info:
      'Die bereitgestellten Informationen werden für einen Zeitraum von Dienst für die Benutzeridentifikation, Statistiken verwendet / gespeichert werden, Konten verknüpft CS und dergleichen. Grundlegende Informationen und bieten die erforderlichen Elemente sind die Informationen, die zur Verfügung gestellt werden müssen, die COCOFX Dienste zu nutzen.',
    agree_request: 'Angebote',
    agree_msg2:
      'Sobald vereinbart, werden die Informationen in Übereinstimmung mit den Allgemeinen Geschäftsbedingungen und Datenschutzrichtlinien des Service verwaltet.',
    agree: 'zustimmen',
  },
  pay_head_foot: {
    account_management: 'Kontoverwaltung',
    settlement_account_list: 'Abrechnungskontoliste',
    account_summary_views: 'Kontoübersicht Ansichten',
    fund: 'Mittel',
    history: 'Billing Geschichte',
    help: 'Hilfe',
    qa: 'Kontaktieren Sie uns',
    fee: 'Kommission',
    secure: 'Sicherheit',
    go_shop: 'Einkaufen',
    my_info: 'Mein Profil',
    my_page: 'Kontoeinstellungen',
    out: 'ausloggen',
    in: 'Login',
    about: 'über',
    blog: 'Blogs',
    employ: 'Jobs',
    site_map: 'Sitemap',
    developer: 'Entwickler',
    partner: 'Partner',
    privacy_state: 'Datenschutz',
    usage: 'Nutzungsbedingungen',
    feed_back: 'Rückkopplung',
    warn_to_consumer:
      'Mitteilung an die Kunden: die Besitzer von Prepaid-Zahlungsmittel COCOBANK ⓒ Cocofx Pty Ltd erfordert nicht die Zustimmung der australischen Finanzaufsichtsbehörde. Bitte lesen Sie die Allgemeinen Geschäftsbedingungen.',
  },
  continue: 'Fortsetzung',
  pay_home: {
    cocobank_title: 'COCOBANK',
    platform: 'Plattform',
    platform_rental: 'Vermietung Plattformen',
    cocopay_is: 'COCOBANK ist das Wachstum des Unternehmens',
    help: 'Zu helfen.',
    home_banner_1:
      'Die Erweiterung der potenzielle Kundenbasis auf der ganzen Welt, und Zahlungsmanagement zu erleichtern,',
    home_banner_2:
      'Business-Verkäuferschutz * und ermöglicht eine sichere mit 24/7 Betrugsüberwachung zum Einkaufen.',
    home_banner_3: 'Sie können leichter gelingen.',
    home_banner_warn:
      '* Geschäftsbedingungen gelten für den Schutz Verkäufer. Bitte beachten Sie Ihren Vertrag für weitere Einzelheiten über die Förderfähigkeit.',
    home_banner_join: 'Melden Sie sich kostenlos.',
    home_sec1_openShop: 'Sie können einen Speicher in COCOBANK öffnen.',
    home_sec1_btn: 'Zur Bewältigung',
    home_sec2_h2: 'Holen Sie sich die gewünschte Zahlungsmethode.',
    home_sec2_text1:
      'COCOBANK kann auch Zahlungen erhalten online, mobil, und sogar eine E-Mail.',
    home_sec2_text2:
      'Ob die COCOBANK verkauften überall, die mit einfacher und sicherer Zahlung unterstützen.',
    home_sec2_online_pay: 'Online-Zahlung',
    home_sec2_online_text:
      'Bezahlung Tasten für einfache verfügbar COCOBANK ist sehr praktisch, wenn Geldzahlungen erhalten und regelmäßige Zahlungen, Spenden etc. Mit COCOBANK Checkout können Kunden Zahlungen schneller und einfacher machen.',
    home_sec2_online_more: 'Sehen Sie mehr Online-Zahlung',
    home_sec2_voice_invoice: 'E-Mail-Rechnung',
    home_sec2_voice_text:
      'Einfach E-Mail-Anfrage für die Zahlung an die professionellen kostenlose Rechnung. Kunden in Übersee sind sowie für Kunden, die nicht COCOBANK Konto.',
    home_sec2_voice_more: 'Sehen Sie mehr über E-Mail-Rechnungen',
    home_sec2_exchange_pay: 'Machen Sie eine Zahlung an der Börse',
    home_sec2_exchange_text:
      'Mit dem integrierten Brieftaschenservice an der Börse können Sie Münzen an jeder Börse von Partnerunternehmen aufladen und kaufen und verkaufen.',
    home_sec2_exchange_more: 'Weitere Informationen zum Umtausch',
    home_sec2_mobile_pay: 'Erhalten Sie mobile Zahlungen',
    home_sec2_mobile_text:
      'Lösungen für mobile automatisch optimiert. Holen Welt, wo noch einfacher zu Bezahlung durch die mobile Website oder die Android und iOS-Apps.',
    home_sec2_mobile_more: 'Sehen Sie mehr über mobile Zahlungen',
    home_sec3_h2: 'Mehr Arbeit mit COCOBANK freiem Partner.',
    home_sec3_global:
      'COCOBANK wird die weitere globalen Chancen mit der Top-freien Websites der Welt verbinden.',
    home_sec3_btn: 'Überprüfen COCOBANK für freie',
    home_sec4_h2: 'Es ist einfach, um loszulegen.',
    home_sec4_banner1:
      'Erfahren Sie alles, was Sie benötigen, aus COCOBANK Business Hub zu starten.',
    home_sec4_banner2:
      'Schließen Sie sich das Geschäftskonto und überprüfen Sie Ihre E-Mail-Adresse',
    home_sec4_banner3: 'Zertifiziert auf das Bankkonto',
    home_sec4_banner4: 'Wählen Sie eine Zahlungslösung',
    home_sec5_h2: 'Warum die Welt viele Betreiber <br/>tun Vertrauen COCOBANK.',
    home_sec5_sub_text:
      'Denn es ist eine ausgezeichnete Wahl. COCOBANK Sie den Verkäufer mit 25 Anrufen mindestens zwei hundert Millionen Menschen in mehr als 200 Märkten weltweit an den Kunden zu verbinden.',
    home_sec5_sub_text_1: 'Denn es ist eine ausgezeichnete Wahl. ',
    home_sec5_sub_text_2:
      'COCOBANK Sie den Verkäufer mit 25 Anrufen mindestens zwei hundert Millionen Menschen in mehr als 200 Märkten weltweit an den Kunden zu verbinden.',
    home_sec5_h3: 'Sicherheit.',
    home_sec5_h3_sub1:
      'Automatische Bestimmung Betrug, 24-Stunden-Überwachung Transaktionen und die Verkäufer und Käuferschutz-Programm für Ihr Unternehmen und Ihre Kunden zu schützen.',
    home_sec5_h3_more: 'Sehen über Online-Zahlung',
    home_sec5_h31: 'Die Welt verwendet.',
    home_sec5_h31_sub1:
      'Auf der ganzen Welt, ohne dass die Angaben jedes Mal, wenn Sie eine Zahlung schnell machen einzugeben. In 203 Märkten in 26 Währungen können Sie per Kreditkarte, Debitkarte oder COCOBANK zahlen.',
    home_sec5_h31_more: 'Sehen über E-Mail-Rechnungen',
    home_sec5_h32: 'Schnell.',
    home_sec5_h32_sub1:
      'In den meisten Fällen, wenn ein Kunde die Zahlung sofort auf Ihr Konto gutgeschrieben COCOBANK. Belastete Bank oder eine Zahlung an den Verkäufer oder Verwendung frei an jedem Ort, wo COCOBANK Zahlung möglich.',
    home_sec5_h32_more: 'Sehen über eBay Verkauf',
    home_sec6_h2: 'Einfache Gebührenstruktur',
    home_sec6_sub:
      'COCOBANK wird eine Gebühr berechnet nur, wenn die Verkäufe. COCOBANK Kosten werden nach Standort des Kunden und die Höhe des Umsatzes festgelegt.',
    home_sec6_more: 'Sehen Sie mehr über Gebühren',
    home_sec7_h2: 'Gemeinschaft für Südkorea Verkauf, CBT LAB',
    home_sec7_text1:
      'Cross-Border Trade Institute (CBT LAB) ist eine COCOBANK Korea (COCOBANK Korea) Händler-Community für Übersee E-Commerce gesponsert aktiviert.',
    home_sec7_text2:
      'CBT LAB hilft, die East Coast Unternehmen wachsen global Aktieninformationen wie die neuesten Trends, Tipps und Best Practices.',
    home_sec7_more: 'Erfahren Sie, wie die Vorteile von CBT LAB nehmen',
    home_sec8_h2: 'Treffen Sie die Partner ineinander greif COCOBANK.',
    home_sec8_text1: 'professionelle Hilfe für Ihr Online-Geschäft müssen?',
    home_sec8_text2:
      'Web-Hosting-Lösungen, Einkaufswagen, E-Commerce-Lösungen, wie vorher Werke COCOBANK Partner dieser Hilfe wird Ihr Unternehmen gekauft.',
    home_sec8_text3: 'Finden COCOBANK einen Partner für mein Geschäft jetzt.',
    home_sec8_more: 'Weitere Partner',
    home_sec9_h2:
      'Werden Sie ein globaler Verkäufer. Dies wird COCOBANK zusammen.',
    home_sec9_h2_1: 'Werden Sie ein globaler Verkäufer.',
    home_sec9_h2_2: 'Dies wird COCOBANK zusammen.',
    home_sec9_btn: 'Eröffnen Sie jetzt ein Konto',
    home_learn_h2: 'Erfahren Sie mehr',
    home_learn_li1: 'Web Payment Solution',
    home_learn_li1_1: 'Website-Zahlungslösungen',
    home_learn_li1_2: 'COCOBANK Kasse',
    home_learn_li1_3: 'Kaufen bei eBay',
    home_learn_li1_4: 'Lösungen vergleichen',
    home_learn_li2: 'andere Zahlungen',
    home_learn_li2_1: 'COCOBANK E-Mail-Rechnungen',
    home_learn_li2_2: 'Mobile Commerce',
    home_learn_li2_3: 'Geschäft für automatische Zahlungen',
    home_learn_li2_4: 'COCOBANK für B2B',
    home_learn_li2_5: 'COCOBANK für freie',
    home_learn_li3: 'COCOBANK Einrichtung und Integration',
    home_learn_li3_1: 'COCOBANK Business Hub',
    home_learn_li3_2: 'COCOBANK Korea Händler Gemeinschaft (CBT LAB)',
    home_learn_li3_3: 'In COCOBANK COCOBANK auf der Website',
    home_learn_li3_4: 'Schauen Sie sich beste Führer Set',
    home_learn_li3_5: 'Entwickler',
    home_learn_li3_6: 'Partner',
    home_learn_li3_7: 'Wie COCOBANK',
    home_learn_li4: 'Verwalten Sie Ihr Konto',
    home_learn_li4_1: 'COCOBANK Business-Anwendungen',
    home_learn_li4_2: 'Geschäftskonto-Einstellungen',
    home_learn_li4_3: 'Verkäufer-Schutz-Programm',
    home_learn_li4_4: 'Verwalten von Kundenbeschwerden',
    home_learn_li4_5: 'Verständnis Chargebacks (Chargeback)',
    home_learn_li4_6: 'Verständnis Kontobeschränkungen',
    home_learn_li4_7: 'Fraud Prevention Tipps',
    home_learn_li4_8: 'PCI Compliance',
  },
  pay_nav: {
    view_your_account: 'Zeigen Sie Ihr gesamtes Konto an',
    account_summary_views: 'Kontoübersicht Ansichten',
  },
  pay_login: {
    secure_sub_title: 'Anmeldung und Sicherheit',
    secure_my_profile: 'Mein Profil',
    secure_update_complete:
      'Das Umweltprofil und Einstellungen wurden aktualisiert.',
    secrue_suggest: 'Jedes Mal, wenn Sie uns Ihre Erfahrung.',
    search: 'Wiederauffinden',
    my_info: 'persönliche Informationen',
    update: 'Aktualisierung',
    e_mail: 'E-Mail',
    default: 'Basisinformationen',
    call: 'Telefon',
    phone: '(Mobile)',
    pay_mobile: 'Mobile Payment',
    trading: 'Give-and-take',
    password: 'Kennwort',
    change: 'Veränderung',
    secure_qa: 'Sicherheitsfrage',
    staying: 'Angemeldet bleiben für eine schnellere Einkäufe in',
    edit: 'Kompilation',
    browse_manage:
      'Verwalten Sie das ausgewählte Gerät und den Browser Login Zustand zu halten.',
    account_type: 'Kontoarten',
    account_delete: 'Kontoauflösung',
    business: 'Unternehmen',
    edit_email: 'Bearbeiten E-Mail-Adresse',
    change_email: 'Ändern E-Mail-Adresse',
    update_email: 'Fügen Sie Ihre E-Mail',
    eamil_url: 'E-Mail-Adresse',
    update_email_url: 'Fügen Sie Ihre E-Mail-Adresse',
    error_email:
      'Entschuldigung. Die Standard-E-Mail kann nicht bearbeitet werden.',
    confirm_new_email: 'Prüfen Sie, ob neue E-Mail-Adresse',
    change_mail: 'E-Mail ändern',
    confirm: 'Bestätigung',
    changing: 'Veränderung',
    deleting: 'Löschung',
    reaming:
      'Derzeit gibt es zwei von der E-Mail-Adresse mit Ihrem Konto verknüpft. Sie können mehr zu 5 E-Mail hinzufügen.',
    qa_1: 'Was ist der Name der ersten Schule besucht?',
    qa_2: 'Wie lautet der Name des ersten Haustiers?',
    edit_phone: 'Bearbeiten Sie eine vorhandene Telefonnummer',
    korea: 'Republik Korea',
    explanation:
      'Durch das Hinzufügen der Zahl bestätige ich, dass Sie automatisch zustimmen wählen und erhalten vorab aufgezeichnete Anrufe und Text auf dem Grunde je für die Behörde zwei Zahlen zu addieren sind in der Datenschutzrichtlinie beschrieben. Standard Preise gelten.',
    edit_phone_num: 'Ändern Telefonnummer',
    edit_password: 'Kennwort ändern',
    confirm_password: 'Überprüfen Sie Ihr aktuelles Passwort',
    new_passod: 'neues Passwort',
    confirm_password_new: 'Neues Passwort bestätigen',
    secure_question: 'Sicherheitsfrage',
    secure_pick: 'Choice-Fragen',
    secure_answer: 'Antwort',
    edit_browse:
      'Mit COCOBANK One Touch können Sie schnell die Zahlung abschließen, ohne jedes Mal einloggen zu müssen.',
    already_log: 'Die an der Maschine angemeldet.',
    off_all: 'COCOBANK One Touch auf alle Ihre Geräte',
    support:
      'PayPal ist zu 100% Kundenzufriedenheit verpflichtet. Wenn Sie ein Problem mit Ihrem Konto',
    support_center: 'Kunden-Support',
    support_text1: 'Oder schauen Sie die',
    support_text2: 'Bitte beachten Sie.',
    support_warn:
      'Wenn Sie Ihr Konto kündigen, können Sie kündigen Ihr Konto nicht Datensätze werden auch und Zuverlässigkeit Ebenen verschwinden.',
  },
  help: {
    support_center: 'Unterstützung',
    resolution_center: 'Dispute Resolution Center',
    qa_search: 'Suchen Häufig gestellte Fragen',
    common_qa: 'Allgemeine Fragen',
    common_qa_1:
      'Was `Warum wird eine Fehlermeldung nach der Aktualisierung des Status Ihrer Bestellung über die‚Get Verbindungen Mittel angezeigt?',
    common_qa_2: 'Wie hebe ich Geld von Korea COCOBANK Konto?',
    common_qa_3:
      'Wie kann ich eine Debit- oder Kreditkarte auf mein Konto COCOBANK hinzufügen?',
    common_qa_4:
      'COCOBANK Ich habe mein Konto Passwort. Wie kann ich mein Passwort zurücksetzen?',
    common_qa_5: 'Kann ich cancel bereits Zahlungsbetrag COCOBANK geschickt?',
    common_qa_6: 'Wie erhalte ich Zahlungen über COCOBANK?',
    common_qa_7: 'Wie kann ich die Zahlung per COCOBANK schicken?',
    common_qa_8: 'Wie füge ich ein Bankkonto zu COCOBANK Konto?',
    common_qa_9:
      'Wie kann ich das Bankkonto mit meinem Konto COCOBANK zugeordnet überprüfen?',
    common_qa_10: 'Wie deaktiviere ich das Konto COCOBANK Grenze?',
    technical_support: 'Melden Sie sich an technischen Fragen und Updates.',
    condition_cocopay: 'Ansicht COCOBANK Zustand',
    muliple_help: 'Weitere Möglichkeiten, um Hilfe zu erhalten',
    trading_help: 'Zur Lösung solcher Probleme Deal',
    tex_center: 'Tax Center',
    tex_help: 'Finden Steuerformulare und andere Ressourcen',
    need_help: 'Kontaktieren Sie uns',
    help_center: 'Kontakt Kundendienst',
    help_to_center: 'Kontakt Kundendienst',
    prepare: 'In Kürze.',
    fast_help:
      'Bitte geben Sie uns Ihr Problem, damit wir schnelle Hilfe COCOBANK.',
    my_search: 'Suchen Sie nach My Problem',
    common_problem: 'Häufige Probleme',
    login_problem: 'Probleme bei der Anmeldung',
    unkown_charge: 'Unberechtigter Zugriff oder unbekannte Forderungen Bericht',
    send_money: 'Senden Sie Geld',
    get_fund: 'Empfangen von Geld',
    withdraw_money: 'Geld abheben',
    pay_cancel: 'Zahlung oder stornieren bestellen',
    pay_hold: 'Zahlung anhängig oder warten',
    refund: 'Rückerstattungen',
    pre_pament: 'Vorab genehmigte Zahlungen',
    negative_balance: 'Negative Balance',
    account_qa_1:
      'COCOBANK den Zustand von meinem Konto abheben, obwohl es als „abgeschlossen“ zeigt Warum ist Geld, das nicht über ein Bankkonto enthält?',
    account_qa_2:
      'Was ist der Grund für meinen Rückzug COCOBANK ist immer noch ein „pending“ Status?',
    account_qa_3: 'Warum anhängig war mein Rückzug?',
    item_title: 'Zugang Passwort und Konto',
    item_title_2: 'Konto Kontoeinstellungen',
  },
  business: {
    no_trade: 'Es gibt keine möglichen Devisenmärkte.',
    view_your_account: 'Zeigen Sie Ihr gesamtes Konto an',
    available: 'verfügbar',
    calculate_late:
      'Wir zeigen den aktuellen Asset des wichtigsten CCF-E-CCF-Feldes.',
    payment_transfe: 'Der Zahlungsverkehr',
    exchange: 'Geldwechsel',
    currency_update: 'call',
    update_btn: 'Plus-Taste',
    currency_cal: 'Währungsrechner',
    pay_default: 'Zahlungseinstellungen',
    payment_send: 'Senden oder Anfrage Zahlungs',
    account_list: 'Kontoliste',
    no_alias: 'keine Aliase',
    new_bank: 'Schließen Sie die neue Bank',
    card: 'Karte',
    new_card: 'Schließen Sie die neue Karte',
    credit: 'Kredit',
    preference_payment: 'Wählen Sie Ihre Online-Zahlungsmethoden.',
    payment_tip:
      'Beim Online-Shopping oder das Senden von Zahlung für Waren und Dienstleistungen dieses Mittel verwenden. Sie können eine andere Zahlungsmethode bei der Kasse jederzeit zur Verfügung.',
    payment_more: 'Erfahren Sie mehr über Ihre Zahlungseinstellungen',
    paymnet_changes: 'COCOBANK Balance',
    debit_card: 'Debit Card',
    currency_tip:
      'Wenn Sie eine Währung hinzufügen, werden alle in dieser Währung zukünftigen Zahlungen an die entsprechenden Mittel gutgeschrieben. Die Basiswährung verwendet, um eine Zahlung oder die Aufforderung zur Zahlung zu senden.',
    currency_1: 'Australischer Dollar',
    currency_2: 'Schweizerfranken',
    currency_3: 'Tschechische Krone',
    currency_4: 'dänische Krone',
    currency_5: 'Euro',
    currency_6: 'Britisches Pfund',
    currency_7: 'Hong Kong Dollar',
    currency_8: 'Forint',
    currency_9: 'Schekel',
    currency_10: 'mexikanischer Peso',
    currency_11: 'Norwegen Krone',
    currency_12: 'Neuseeland-Dollar',
    currency_13: 'Philippinischer Peso',
    currency_14: 'Polnischer Zloty',
    currency_15: 'russischer Rubel',
    currency_16: 'schwedische Krone',
    currency_17: 'Singapur-Dollar',
    currency_18: 'Baht',
    currency_19: 'Neuer Taiwan-Dollar',
    withdraw_account: 'Rückzug Konto',
    exchanged: 'Nach dem Wechsel',
    exchange_rate: 'Wechselkurse',
    exchange_tip:
      'Der Wechselkurs wird ein geschätzter Betrag basierend auf dem aktuellen Wechselkurs, die Wechselgebühr ist bereits im COCOBANK enthalten.',
    currency_default:
      '(A) Der japanische Yen ist auf die Standardwährung festgelegt.',
    currency_default_notice:
      'Die Basiswährung verwendet, um eine Zahlung oder die Aufforderung zur Zahlung zu senden.',
    currency_default_notice2:
      'den Anruf Closing wird nicht auf der Waage angezeigt erhält keine Zahlung an den Anruf.',
    currency_default2: 'JPY (s), der Standard',
    currency_quit_jp_btn: 'Close-Dollar',
    currency_quit_btn: 'Close Call',
    bank_account: 'Konten',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'Guthaben',
    bank_account_check: 'bestätigende Bank',
    bank_account_remove: 'Delete Bank',
    bank_continue: 'Möchten Sie fortfahren?',
    bank_tip:
      'Schwebende Geschäfte mit den Banken werden nach dem Löschen verarbeitet.',
    bank_this_delete: 'Delete Bank',
    card_tip:
      'Das COCOBANK Konto Möchten Sie, es zu benutzen, ohne dafür oder Auszahlungslimits?',
    card_confirm: 'Schauen Sie sich die Karte.',
    card_type: 'Typ',
    expiry_date: 'Ablauf',
    card_adress: 'Rechnungsadresse',
    card_update: 'Karte aktualisieren',
    card_delete: 'Delete-Karte',
    card_this_delete: 'Delete-Karte',
    card_tip2:
      'Diese Zahlungsmethode wird derzeit bevorzugt. Nach der Fertigstellung können Sie eine andere bevorzugte Zahlungsmethode festgelegt. Deal anhängig ist mit (a) nicht definiert ist nach dem Löschen behandelt.',
    secure_code: 'Sicherheits-Code',
  },
  shop: {
    shop_list: 'Speicher-Liste',
    shop_create: 'Shop erstellt',
    shop_cre_date: 'zusätzlich',
    shop_title: 'Speichername',
    shop_id: 'Shop-ID',
    shop_state: 'Zustand',
    shop_work: 'Arbeit',
    shop_detail: 'mehr',
    shop_retouch: 'Kristall',
    shop_settlement: 'Verrechnungskonten Liste',
    shop_history: 'Transaktionen',
    no_shop_list: 'Es gibt keine Liste von Geschäften',
  },
  merchant: {
    create: 'Shop-Anmeldung',
    update: 'Anmeldung',
    retouch: 'Shops geändert',
  },
  pay_legal: {
    service_usage: 'COCOBANK Nutzungsbedingungen',
    detail_usage:
      'Diese Allgemeinen Geschäftsbedingungen werden dem Asien-Pazifik, Lateinamerika und einigen europäischen Ländern, dem Nahen Osten und Afrika Benutzer gelten. Um die Bedingungen für verschiedene Länder oder Regionen anzuzeigen, wählen Sie aus der Liste unten.',
    nation: 'Wählen Sie ein Land',
    every_consumer: 'Alle Benutzer',
    service_agree: 'Ihr Vertrag für den Service COCOBANK',
    privacy_state: 'Datenschutz',
    purpose_policy: 'COCOBANK Use Policy',
    payment_agreement: 'COCOBANK alternative Zahlungsmethode Vereinbarung',
    sell_buy: 'Händler und Geschäft',
    shop_policy: 'COCOBANK Unterstützung Store-Richtlinien',
    contract_profit: 'Contract for-Profit-Unternehmen',
    billing_agreement: 'Abrechnungsvereinbarung',
    direct_debit_agreement: 'COCOBANK Mittel erhalten und Debit Vereinbarungen',
    additional_info: 'Weitere Informationen',
    infringement: 'Somyeongseo Richtlinienverletzungen',
    policy_update: 'Aktualisierte Richtlinien',
    warn1:
      'Benachrichtigen Verbraucher: COCOBANK Zahlungsservice als Prepaid-Zahlungsmittel (Stored Value Facility) gemäß australischem Recht angesehen wird.',
    warn2:
      'COCOBANK die Besitzer von Prepaid-Zahlungsmittel ⓒ Cocofx Pty Ltd die Genehmigung der australischen Finanzaufsichtsbehörde nicht erforderlich. Wir empfehlen auch die Verbraucher (Nutzer) sind diese Allgemeinen Geschäftsbedingungen sorgfältig lesen.',
    warn3:
      'Diese Nutzungsbedingungen und Hinweise liefern, die Bedingungen im Zusammenhang mit einer bestimmten COCOBANK Dienstleistungen.',
  },
  pay_privacy: {
    effective_day: 'Datum des Inkrafttretens: 28. März 2019',
    summary: 'Zusammenfassung',
    personal_data: 'Persönliche Daten von COCOBANK gesammelt',
    personal_date_cause:
      'Gründe, um Ihre persönlichen Daten COCOBANK zu halten',
    summary_1: 'Unsere Nutzer sind',
    summary_2: 'Seiten',
    summary_3: 'oder besuchen',
    summary_4: 'Service',
    summary_5: 'Bei der Verwendung der Benutzer',
    summary_6: 'persönliche Daten',
    summary_7:
      'Wie zu sammeln und zu speichern, verwalten und zu teilen, zu erklären, dass die Übertragung dieser Datenschutzrichtlinie vorbereitet hat. Diese Datenschutzrichtlinie auf Ihre persönlichen Daten gilt, wenn unsere Website besuchen oder den Service nutzen, andere COCOBANK',
    summary_8: 'Benutzer',
    summary_9:
      'Es gilt nicht für Websites oder Online-Web-COCOBANK nicht oder Anpassungen im Besitz, einschließlich Service-Website oder eine Dienstleistung.',
    summary2_1:
      'COCOBANK besuchen Sie unsere Websites oder persönliche Daten, wenn Sie die folgenden Arten von Dienstleistungen verwenden.',
    summary2_2: 'Wählen Sie mit und Informationen',
    summary2_3:
      'Wenn Sie ein Konto registrieren und die Dienste von COCOBANK zu verwenden, um die Informationen zu erfüllen, um persönliche Daten zu sammeln, um den Dienst zu schaffen, durch den Benutzer angefordert.',
    summary2_4:
      'In Abhängigkeit von den Leistungen ausgewählt haben, können Sie bitten, die Identifikationsinformationen zur Verfügung zu stellen erforderlich, um einen Benutzernamen, Postanschrift, Telefonnummer, E-Mail-Adresse, Konto zu erstellen.',
    summary2_5:
      'Bedingungen können Sie zusätzliche persönliche Daten zu liefern, bitten, auf dem Service abhängig.',
    summary3_1: 'Erfahrungen mit dem Handel und Informationen',
    summary3_2:
      'Nutzung der Dienste von COCOBANK oder wenn der Zugriff auf die Website, beispielsweise vom Verkäufer kaufen, oder der Empfang von Geld oder wenn eine Zahlung oder senden Geld an Freunde und Familie der Verarbeitung collect anderen Handelsbezogenen Informationen sowie Transaktionsinformationen von COCOBANK die. Andere handelsbezogene Informationen enthalten das Senden oder Geld anfordern, Waren oder Geld-Zahlungsservice, mit dem Verkäufer, einschließlich Informationen über alle Zahlungsmethoden verwendet, um die Transaktionsinformationen und Geräteinformationen zu vervollständigen, Technologiedaten, Standortinformationen und dergleichen.',
    summary4_1: 'Teilnehmerinformationen',
    summary4_2:
      'Wenn Sie die Website COCOBANK Service sammelt persönliche Daten verwenden oder den Zugang, dass die Nutzer über andere Teilnehmer in der Transaktion beteiligt bieten.',
    summary4_3: 'Senden oder fordern Geld',
    summary4_4:
      'Wenn Sie Geld über den Dienst COCOBANK senden oder fordern Sie sammeln Ihren Namen, Postanschrift, Telefonnummer, wie persönliche Daten wie erhalten Geld von Ihren Finanzkontodaten des Teilnehmers des Geld zu Ihnen schicken.',
    summary4_5:
      'Der Umfang der personenbezogenen Daten in Bezug auf die Teilnehmer aufgefordert können auf den Dienst verwendet werden, variieren in Abhängigkeit oder Anforderung, Geld zu senden.',
    summary5_1:
      'Die Zahlung für andere Menschen anstelle von Rechnungen oder Rechnung an eine andere Person Anträge auf Auszahlung',
    summary5_2:
      'Wenn Sie COCOBANK Service um sie zu bitten, die Rechnung im Namen einer anderen Person zu zahlen oder Ihre Rechnungen in ihrem Namen an einem anderen Benutzer zu zahlen, die Benutzername, Postanschrift, Telefonnummer, E-Mail-Adresse, Benutzer Abrechnung anstelle von Rechnungen oder andere der Kontoinhaber relevante persönliche Daten sammeln müssen, einschließlich Kontonummer, die Sie stattdessen zu zahlen.',
    summary6_1: 'Fügen Sie Geld auf Ihr Konto',
    summary6_1_1: 'Ihr Konto',
    summary6_2:
      'Um Geld auf andere Konten in dem Konto des Benutzers oder der Benutzer kann eigene hinzufügen, oder wenn Sie COCOBANK Service Anfrage verwenden, um die Menge in diesem Konto an die anderen Nutzer auf der anderen Seite vom Benutzer hinzugefügt werden, um effizient Ihre Anfrage zu bearbeiten Informationen zu sammeln oder Informationen über Sie von der anderen Seite sammeln.',
    summary6_3:
      'Zum Beispiel Laden oder die Dienste COCOBANK Anforderung mit dem Betrag auf dem Konto auf ein Mobiltelefon hinzugefügt werden, können Sie andere Informationen sammeln, einschließlich personenbezogener Daten und mobile Kontonummer von den anderen Teilnehmern.',
    summary7_1:
      'Informationen zu der Person auf Ihren Freunden und Kontakte in Bezug',
    summary7_2:
      'Wenn der Benutzer die Kontaktliste in Ihrem Konto verbunden ist, ist es einfacher, die Menschen helfen, mit, wenn COCOBANK mit deinen Freunden und Kontakten umgehen zu geben. Damit der Benutzer das Gerät verwenden kann, oder eine Verbindung zwischen Social-Media-Plattformen oder Geräten COCOBANK Konten oder Social Media eingerichtet, wenn die Plattform besser COCOBANK Dienste verbunden erheben und verwenden Ihre Kontaktlisten Informationen (Namen, Adresse, E-Mail-Adresse usw.) in COCOBANK die Umwelt verbessern.',
    summary8_1:
      'Die Informationen, die Sie zur Verfügung zu stellen COCOBANK um bestimmte Online-Dienste zu nutzen oder zusätzliche Dienstleistungen',
    summary8_2:
      'Wenn die Anforderung oder bei der Auswahl der Website teilnehmen zu Anfragen für neue Funktionen oder verbesserte Dienstleistungen oder andere optionale Funktionen, können Sie zusätzliche Informationen über die Nutzer in COCOBANK sammeln.',
    summary8_3:
      'Wenn die Methoden zu sammeln Informationen von diesen Diensten verwendet von den in dieser Datenschutzerklärung angegeben, sammelten die Informationen während einer gesonderten Mitteilung.',
    summary9_1:
      'Informationen für den Benutzer, wenn die „COCOBANK Nichtzahlung“ Service mit',
    summary9_2:
      'Für einige begrenzte Dienste können sich anmelden müssen oder Ihre Kontoeinstellungen Nichtzahlung verwenden. COCOBANK wird Ihre persönlichen Daten, alle Zahlungsmethoden relevante Geräteinformationen, Technologiedaten, Standortinformationen, die für die Benutzer sammeln, um die Transaktion abzuschließen. Wenn Sie den Kontoinhaber und die Zahlung für den Nichthandel auswählen, können Sie bauen und collect Transaktionsinformationen mit Ihrem Konto verknüpft.',
    summary9_3:
      'Wenn der Benutzer während nicht der Kontoinhaber und die Zahlung für das nicht-COCOBANK Angebot auswählen, erfassen und speichert alle Informationen, die Sie verwenden und in Übereinstimmung mit den Informationen in dieser Datenschutzrichtlinie geteilt.',
    summary10_1: 'Anwenderspezifische Informationen von Dritten erhalten',
    summary10_2:
      'Von einem Dritten, wie Händler, Datenlieferanten, Auskunfteien, soweit dies gesetzlich zulässig ist, können Sie die Informationen erhalten.',
  },
  partner: {
    be_partner: 'Werden Sie Partner von COCOBANK.',
    banner_text:
      'Shopping-Plattform Anbieter, Marktplatz, gibt es eine Abrechnung Unterstützung Betreiber, die einen Zahlungsdienstleister verlangen kann ein Partner von COCOBANK sein.',
    banner_btn: 'Um Kontakt mit Ihrem Account Manager',
    benefit: 'COCOBANK Vorteile, die Partner sind berechtigt,',
    benefit_1: 'Integration und technische Unterstützung für Baulösungen',
    benefit_2:
      'Sie erreichen unser Support-Team wenden Sie Hilfe bei der COCOBANK Integration zu erhalten. COCOBANK Entwicklerportal kann auch als Ressource genutzt werden.',
    benefit_3: 'Geschäftswachstum durch Marketing-Möglichkeiten',
    benefit_4:
      'Nutzen Sie die vielen Marketing-Möglichkeiten zur Verfügung gestellt COCOBANK potenzielle Kunden anziehen können.',
    traction: 'Und das Abschleppen Zahlungen auf der ganzen Welt.',
    traction1:
      'COCOBANK Partner eine innovative Plattform für eine reibungslose Abwicklung von Verkäufern Vertrauen COCOBANK unterstützen.',
    traction_btn: 'Weitere Partner',
    program: 'COCOBANK Partner-Programm ist frei zu verbinden.',
    program_1:
      'Bitte füllen Sie das Online-Formular aus, wir werden Sie in COCOBANK kontaktieren.',
    program_2:
      'Beschreiben Sie bitte die Betriebs- und laufenden Geschäftslösungen.',
    program_3:
      'Bitte kontaktieren Sie COCOBANK die notwendigen Änderungen zu diskutieren.',
    program_4:
      'COCOBANK integrieren und helfen sicherzustellen, dass sie die Zahlung COCOBANK erhalten.',
    program_btn: 'Um Kontakt mit Ihrem Account Manager',
    common_qa: 'Häufig gestellte Fragen',
    common_qa1: 'Gibt es einen Anbieter COCOBANK Partner?',
    common_qa1_text:
      'COCOBANK Partner ist das B2B (Business-to-Business) Unternehmen, das bietet seinen Kunden Lösungen COCOBANK. COCOBANK arbeitet mit Organisationen wie der Einkaufswagen, Web-Hosting-Unternehmen, Web-Entwickler, Logistikanbieter und digitale Marketing-Agentur, Payment-Gateway.',
    common_qa2: 'Was COCOBANK in Betracht kommenden Partner?',
    common_qa2_text: 'Kontaktieren Sie Ihren Account Manager',
    common_qa2_text_2:
      'Sie können Beratung über die Qualifikation des Partners zu bekommen.',
    common_qa3: 'Wir bieten integrierte Support-Service im COCOBANK?',
    common_qa3_text:
      'Sobald die Genehmigung in der Partner-Programm und COCOBANK registriert zu verbinden, können Sie die wertvollen integrierte Dokumentation und Entwicklerforen zuzugreifen. Es kann auch eine integrierte Unterstützung für Berater für das Zertifikat bekommen.',
    common_qa4:
      'Es ist auch ein Geschäft außerhalb von Korea, ich kann separat für jedes Land in dem Partner-Programm anmelden?',
    common_qa4_text:
      'Es hängt von dem Land Sie ein Unternehmen tätig sind. In COCOBANK bereitstellen spezialisierte Partner Vertreter auf die regionalen Anforderungen in den verschiedenen Ländern.',
    common_qa4_more: 'Ansicht Partner-Programm bietet nationale',
  },
  pay_main: {
    total_product: 'Gesamtprodukt',
    total_sum: 'Aggregat',
    pay_this_account: 'Setzen Sie dieses Konto als Zahlungsmethode.',
    bill_show:
      'Die Transaktionsinformation wird angezeigt wie in der Beschreibung folgt.',
    banner_text: 'COCOBANK ist sicherer',
    banner_text2: 'Eine schnelle Zahlung.',
    banner_text3:
      'Egal wo einkaufen Ihre finanziellen Informationen sicher zu halten.',
    footer_1: 'Geschäftsbedingungen',
    footer_2: 'Benutzervereinbarung',
    footer_3: 'Datenschutz',
    footer_4: 'Rückkopplung',
    footer_5:
      'Mitteilung an die Kunden: die Besitzer von Prepaid-Zahlungsmittel COCOBANK ⓒ Cocofx Pty Ltd erfordert nicht die Zustimmung der australischen Finanzaufsichtsbehörde.',
    footer_6: 'Nutzungsbedingungen',
    footer_7: 'Zudem empfehlen wir Ihnen es sorgfältig zu lesen.',
    footer_8: 'Billing',
    wallet: 'E-Wallet-Management',
    last_name: 'Sex',
    card_number: 'Kartennummer',
    three_number: 'dreistellig',
    name: 'Name',
    pay_cocopay: 'Für die Zahlung per COCOBANK',
    free_shipping:
      'Wenn das COCOBANK Konto können Sie frei Verschiffen zurück, Kauf Schutz erhalten.',
    email_phone: 'E-Mail oder Telefonnummer',
    login_error: 'Haben Sie in Schwierigkeiten Unterzeichnung haben?',
    pay_card: 'Zahlung mit Kreditkarte',
    cancel_back: 'Abbrechen und gehen Sie zurück zur vorherigen Seite',
  },
  site_map: {
    site_map_tip: 'Ein Link, die Sie erkunden die COCOBANK Konto helfen.',
    map_fund: 'Mittel',
    map_fund_1: 'Belastete',
    map_fund_2: 'Meine Fähigkeit, das Gleichgewicht zu verwenden ist?',
    map_fund_3: 'Senden oder fordern Geld',
    map_fund_4: 'Call Management',
    map_fund_5: 'COCOBANK meine EC-Karte Rabatte',
    map_fund_6: 'Holen COCOBANK Debitkarte',
    map_fund_7: 'COCOBANK Credit Billing Schedule',
    map_deal: 'Deal',
    map_deal_1: 'Alle Angebote Aktivität',
    map_deal_2: 'Aktivitäten Ansichten (einschließlich Balance und Gebühren)',
    map_deal_3: 'Zum Angebot von Grafiken und Diagrammen',
    map_deal_4: 'Download-Deal',
    map_deal_5: 'Als Reaktion auf eine Forderung oder Charge',
    map_deal_6: 'IPN (sofortige Zahlungsbestätigung) Geschichte',
    map_profile: 'Mein Profil und Einstellungen',
    map_profile_1: 'Business-Spiegel',
    map_profile_2: 'E-Mail, Adresse, Telefon oder Passwort-Update',
    map_profile_3: 'Bankkonto oder Kartenaktualisierung',
    map_profile_4: 'Update-Benachrichtigungen',
    map_profile_5: 'Anzeigen Kontolimits',
    map_profile_6: 'Benutzerverwaltung',
    map_profile_7: 'Liefer-Update-Einstellungen',
    map_support: 'Unterstützung',
    map_support_1: 'Zum Zentrum für Konfliktlösung',
    map_support_2: 'Zum Support Center',
    map_support_3: 'Kontaktieren Sie uns',
    map_support_4: 'COCOBANK Händlergebühr Informationen',
    map_report: 'Bericht',
    map_report_1: 'Bericht einzurichten, zu verwalten oder herunterladen',
    map_manage: 'Werkzeuge',
    map_manage_1: 'Ansicht Werkzeug',
    map_manage_2: 'COCOBANK Taste Management',
    map_manage_3: 'Regelmäßige Zahlungsmanagement',
    map_consum: 'Kunde',
    map_consum_1: 'View Guest Liste',
  },
  fee: {
    fee_tip: 'Einfache Gebührenstruktur',
    fee_banner_1:
      'Im Allgemeinen Kauf ist kostenlos und kann je nach Wechselgebühren sein.',
    fee_banner_2:
      'Wenn der Verkauf nicht mit den COCOBANK monatlichen Gebühren bleiben oder Stornogebühren. Nach jedem Auftrag wird nur dann gezahlt werden.',
    fee_h2: 'Typischerweise Kauf ist frei.',
    fee_text1:
      'Die Gebühren für die Abwicklung von Zahlungen werden vom Verkäufer bezahlt.',
    fee_text2: 'Sie können jedoch Umtauschgebühr angewendet wird.',
    fee_more: 'Verkäufer Gebühren erfahren Sie mehr',
    fee_text3:
      'Zu verkaufen von der Rechnung oder Zahlung E-Mail-Website (internationaler Zahlungsstandardtarif)',
    fee_text4: 'Eine feste Gebühr basierend auf dem Empfang von Anrufen',
    fee_text5: 'Börsengebühren können zusätzlich gelten.',
    fee_text6:
      'Zum Beispiel für eine Gebühr Zahlungseingang festgelegt in USD ist es $ 0,30 USD.',
  },
  dash: {
    more: 'mehr',
    withdraw_asset: 'Fonds Rückzug',
    currency: 'Währung',
    quotes: 'Rechnungen und Schätzungen',
    last_6_months: 'Letzte 6 Monate',
    make_invoice: 'Rechnungserstellung',
    manage_invoice: 'Invoice Management',
    grown_up: 'Bitte senden Sie das Unternehmen für ein Angebot zu wachsen.',
    un_paid_invocie: 'Ausstehende Rechnungen',
    make_quotes: 'Angebotserstellung',
    quotes_1: 'Man hat alle ausstehenden Rechnungen vorgeschlagen.',
    quotes_2: 'COCOBANK Rechnung',
    quotes_alarm: 'Senden Erinnerungen',
    quotes_detail: 'mehr anzeigen',
    quotes_who: 'Bill: Choi, So - Young',
    latest_act: 'Letzte Aktivitäten',
    act: 'Aktivität',
    received: 'empfangene Zahlung',
    send: 'von Zahlung',
    act_record: 'Aktivität (einschließlich Balance und Gebühren)',
    pay_person: 'Biller Menschen',
    show_all: 'alle',
    tell_us: 'Bitte teilen Sie uns Ihre Meinung.',
    feed_text:
      'Nehmen Sie sich einen Moment, um uns auf den neu gestalteten Display Informationen auf dieser Seite um Ihre Meinung zu sagen. Vielen Dank!',
    service: 'Ihr Feedback',
    feed_text_back:
      'Vielen Dank für Ihre Kommentare! Sind diese, wie unsere Website nützlich ist?',
    feed_placeholder:
      'Bitte lassen Sie mich wissen, die Grund, warum ich heute COCOBANK kam es gibt einen besseren Weg. Geben Sie keine persönlichen Daten wie E-Mail oder Kontonummer.',
    feed_p:
      'COCOBANK Office-Mitarbeiter und Gäste auf Ihre Kommentare können intern gebucht werden, so dass Sie es sehen können, lassen Sie keine persönlichen Informationen. Kundenservice Fragen, bitte hier klicken. von COCOBANK',
    feed_protect: 'Datenschutz',
    feed_law: 'Rechtliche Bedingungen',
    feed_or: 'und',
    feed_need: 'sehen',
    trade_name: 'Deal Name',
    trade_id: 'Deal-ID',
    transaction_type: 'Geschäftsart',
    trade_amount: 'Zahlung',
    detail_show: 'Look',
  },
  shop_detail: {
    detail_info: 'Shop Details',
    api_signature: 'Shop Signaturschlüssel',
    msg_shop_create: 'Dieser Shop wird registriert.',
    msg_shop_modify: 'Dieser Shop wurde behoben.',
  },
  merchant_account: {
    create_account: 'Generieren Abwicklungskonto',
    enroll_account: 'Registrierung Abwicklungskonto',
    pls_select_account: 'Wählen Sie Abrechnungskonto',
  },
  transaction_detail: {
    transaction_title: 'Deal Details',
    order_id: 'Shop-Bestellnummer',
    pay_account_title: 'Zahlungskontoname',
    pay_account_number: 'Zahlungskontonummer',
    pay_account_balance: 'Zahlungskontostand',
    pay_account_selection:
      'Wählen Sie ein Konto aus, für das Sie bezahlen möchten.',
    pay_account_selection_msg: 'Bitte wählen Sie ein Zahlungskonto.',
  },
  guide: {
    guide_title_1: 'Coco Bank-Konto',
    guide_title_2: 'Wie wird die Übertragung und Überweisung der Coco Bank?',
    guide_title_3:
      'Nutzen Sie den günstigeren und sicheren Service über das Konto des Coco Bank.',
    guide_strapline_1:
      '① Konten, die sofort ohne Gebühr entfernt werden können',
    guide_strapline_2:
      '② Einfach, schnelles Konto auf einfache Weise zu öffnen',
    guide_strapline_3: 'Vestigieren',
    guide_strapline_4: 'Überweisung',
    guide_strapline_5:
      'Konten, die die meisten Arten von Münzen in Korea einzahlen können',
    guide_strapline_6: 'Sicheres Konto vom Hacken',
    guide_strapline_7: 'Visual History-Anfrage und Empfang verfügbar',
    guide_strapline_8: 'Kann als Corporate-Abrechnungskonto verwendet werden',
    guide_strapline_9:
      'Schnelle Transaktionen durch Konten für C2C- und B2C-Transaktionen',
    guide_strapline_msg_1:
      'Die Kontoübertragung der Coco Bank tritt nicht zur Übertragung von Geld auf.',
    guide_strapline_msg_3:
      'Die Kontoöffnung der Coco Bank beträgt 10 Sekunden.',
    guide_strapline_msg_4: 'Komplexer Prozess verzichtet.',
    guide_strapline_msg_5:
      'Sie können nur den Kontonamen für dieses Vermögenswert erstellen.',
    guide_strapline_msg_6: 'Übertragung über Brieftasche',
    guide_strapline_msg_7: 'Verwenden von Brieftaschenadressen',
    guide_strapline_msg_8: 'Gebührengebühren.',
    guide_strapline_msg_9: 'Überweisung in der Coco Bank',
    guide_strapline_msg_10: 'Mit der Kontonummer verwenden',
    guide_strapline_msg_11: 'Gebühr Null',
    guide_strapline_msg_12:
      'Viele Arten von kryptographischen Anhäufungen werden weltweit erteilt. Die Coco Bank befasst sich mit einer Vielzahl von kryptographischen Anhäufungen, um dem Kundenkomfort in Übereinstimmung mit diesen Änderungen zu helfen.',
    guide_strapline_msg_13:
      'Sicherheit ist der Kern kryptografischer Einschlüsse. Die Coco Bank denkt die wichtigste Sicherheit, und digitale Ingenieure mit mehr als fünf Jahren Erfahrung in jedem Feld haben ein Sicherheitssystem eingerichtet.',
    guide_strapline_msg_14:
      'Sie können die Übertragung zwischen Konten abfragen. Das Konto des Coco Bank kann die Banken zwischen Banken oder anderen Banken überprüfen, z. B. Marktbanken. Bei Bedarf können Sie den Punkt besuchen und den Emissionshistorie überprüfen und ausgeben.',
    guide_strapline_msg_15:
      'Das Konto des Coco Bank ist mit dem Zahlungs- und Abrechnungskonto des Coco-Marktes verknüpft. Nach der Registrierung des Ziel-Kryptographiekontos als Abrechnungskonto können Sie die in dem Coco-Markt verkauften Waren auf einen CryptOPaste begleichen.',
    guide_strapline_msg_16:
      'Gebühren und Verzögerungen treten auf der Transaktion zwischen der Person durch die Brieftasche auf. Die Coco Bank bietet eine Coco-Bank-Kontoüberweisung an, um dies zu lösen. Erleben Sie C2C- und B2C-Transaktionen ohne Gebühr und Verzögerung durch das Konto des Coco Bank.',
  },
  account_transfer: {
    transfer: 'Account Transfer',
    transfer_list: 'Transferhistorie',
    transfer_list_title: 'COCOBank-Kontoübertragung',
    transfer_list_wallet: 'Andere Brieftasche Transfer',
    msg_required_data: 'Bitte geben Sie alle Werte',
    msg_not_select_withdraw_account: 'Bitte wählen Sie das Zahlungskonto',
    create_transfer_title: 'Account Transfer',
    from_account_select: 'Wählen Sie Zahlungskonto',
    available_transfer: 'Überweisungsbeträge',
    to_account_input: 'Transfer Kontonummer Eintrag',
    to_account_confirm: 'Transferkonto Verification',
    to_account_user_name: 'Transferkonto Name des Mitglieds',
    transfer_amount: 'Überweisungsbetrag',
    delete_amount: 'Korrektur',
    all_amount: 'FULL',
    description: 'Erklärung',
    transfer_btn: 'Transfers',
    transfer_info_check: 'Transfer Anforderungsinformationen',
    from_account_number: 'Rückzug Kontonummer',
    from_asset_title: 'Rücktritt Kontobestände',
    to_account_number: 'Übertragen Kontonummer',
    success_transfer: 'Transfer wurde erfolgreich verarbeitet.',
    transfer_list_detail: 'Transfer History &',
    search_transfer_asset: 'Suche nach Immobilien',
    search_transfer_account: 'Suche nach Konto',
    reset: 'Initialisierung',
    search: 'Wiederauffinden',
    transfer_list_detail_tit: 'Übertragen Details Details',
    no_transfer: 'Keine Übertragung Details',
    msg_not_search_account:
      'Kontonummer existiert nicht oder ist nicht gültig Eingang.',
    my_account_transfer: 'Mein Konto Transfers',
    msg_pls_select_account:
      'Durchsuchen Sie nach Auswahl eines Assets das Konto.',
    placeholder_amount: 'Bitte geben Sie den Überweisungsbetrag',
    not_search_user_name: 'Nicht sicher Benutzername',
    msg_select_asset_search: 'Bitte wählen Sie ein Konto',
    success_fail: 'Die Übertragung war nicht erfolgreich.',
    pls_search_asset: 'Suche nach Assets.',
    pls_search_account: 'Suchen Sie Ihr Konto.',
    pls_select_asset: 'Bitte wählen Sie einen Vermögenswert aus.',
    not_exist_account: 'Das Konto des Vermögenswerts existiert nicht.',
    no_inquiry_history: 'Es gibt keine Anfragehistorie.',
    account_number_list_1: 'Vor 6 Monaten Debit kann nicht abgefragt werden.',
    account_number_list_2:
      'Die maximale Anzahl von Ansichten beträgt 6 Monate.',
    account_number_list_3:
      'Präsentieren des aktuellen Übertragungsergebnisses ist eine Seite, die die Anfrage- und Händlerübertragungsergebnisse in der Coco Bank fragt. <br /> Wenn Sie die Ergebnisse der Übertragung mit anderen Geldbörsen anzeigen möchten, überprüfen Sie bitte oben auf der [Handtreuerübertragung] oben.',
    account_number_list_3_1:
      'Die aktuelle Anfrage zum Übertragungsergebnis ist eine Seite für Anfragen innerhalb der COCOBANK und die Übertragungsergebnisse von Partnergeschäften. <br/> Wenn Sie die Überweisungsergebnisse auf Ihr Cocobank-Konto überprüfen möchten, überprüfen Sie bitte oben die [Überweisung des COCOBANK-Kontos]',
    today: 'Tag',
    one_week: '1 Woche',
    one_month: '1 Monat',
    three_months: '3 Monate',
    six_months: '6 Monate',
    withdrawal_account_number: 'Auszahlung der Kontonummer',
    recent_order: 'in jüngster Reihenfolge',
    past_order: 'In früherer Reihenfolge',
  },
  bank_service_center: {
    title: 'Thema',
    date: 'Datum',
    state: 'Zustand',
    enter_search_word: 'Geben Sie Ihre Suchbegriffe ein',
    list: 'Liste',
  },
  service_center: {
    view_all: 'Alle',
    contact_history: 'Anfrageverlauf',
    privacy_Statement: 'Richtlinie zum Umgang mit persönlichen Informationen',
    would_you_agree: 'Möchten Sie dem oben Gesagten zustimmen?',
    mobile_number: 'Handynummer',
    target_of_inquiry: 'Gegenstand der Anfrage',
    inquiry_contents: 'Inhalt der Anfrage',
    please_enter_your_inquiry: 'Bitte geben Sie Ihre Anfrage ein.',
    send: 'Senden',
    normal_inquiries_received: 'Ihre Anfrage wurde erfolgreich empfangen.',
    inquiry_history: 'Anfrageverlauf',
    pls_select_inquiry_type: 'Bitte wählen Sie die Art des Kontakts',
    pls_login_to_use_inquiry: '1 Melden Sie sich an die ersten Anfragen.',
    non_member_login: 'Login für Nichtmitglieder',
    contact_id: 'Kontakt ID',
    view_inquiry: 'Kontakt anzeigen',
    service_center: 'Kundenservice',
    inquiry_details: 'Kontaktdetails',
    msg_enter_title: 'Bitte geben Sie einen Titel.',
    msg_enter_your_content: 'Bitte geben Sie Ihre Informationen.',
    msg_pls_login: 'Bitte Login.',
    go_back: 'zurück',
    re_contact: 'Kontaktmaterial',
    contents: 'Inhalt',
    msg_no_inquiry_history: 'Keine Kontaktdaten.',
    msg_require_login_additional_authentication:
      'Sie müssen angemeldet oder zusätzliche Authentifizierung werden.',
    when_you_member: 'Wenn ein Mitglied',
    msg_inquiry_history_can_view_after_login:
      'Die Mitglieder der Kontaktdaten können nach der Anmeldung eingesehen werden.',
    non_member: 'Bei Nicht-Mitglieder',
    lookup_inquiry: 'Kontaktsuche',
    msg_enter_inquiry_id: 'Bitte geben Sie die Kontakt-ID.',
    msg_enter_password_when_registering_your_inquiry:
      'Bitte geben Sie das Passwort, das Sie setzen, wenn Sie sich registrieren rufen.',
    frequently_asked_questions: 'Häufig gestellte Fragen',
    msg_enter_your_password: 'Bitte geben Sie Ihr Passwort ein.',
    pls_search_fap: 'Bitte suchen Sie unsere Fragen.',
    msg_source_filename_none: 'Es gibt kein angehängtes Bild.',
    super_inquiry: 'oben',
  },
  modal: {
    not_seeing_day: 'Tagsüber nicht gesehen',
  },
  login_guide_modal: {
    title: 'Informationen',
    sub_title:
      'Das Anmeldesystem wird überarbeitet, damit die Mitglieder den Austausch reibungslos nutzen können.',
    content:
      '[Vor dem Wechsel] <br/> ID-Login erstellt, wenn Sie sich zum ersten Mal anmelden <br/><br/> [Nach dem Wechsel] < br / > Ändern Sie Ihre Telefonnummer oder E-Mail-Anmeldung <br/><br/> Um sich anzumelden, bis das Anmeldesystem neu organisiert ist, melden Sie sich einfach mit der ID an, die Sie bei der ersten Anmeldung erstellt haben.',
  },
  affiliate: {
    affiliate_occur_list: 'Zulassungshistorie',
    affiliate_adjust_list: 'Details zur Zulassungsabrechnung',
    allowance_balance_asset: 'Wertberichtigungssaldo nach Vermögenswerten',
    list_allowance_balance_asset:
      'Liste des Wertberichtigungssaldos nach Vermögenswerten',
    search_by_asset: 'Suche nach Asset',
    allowance_search: 'Zulassungssuche',
    generator: 'Generator',
    beneficiary: 'Begünstigter',
    benefactor: 'Wohltäter',
    behavior_type: 'Verhaltenstyp',
    target_unique_number: 'Ziel eindeutige Nummer',
    date_of_occurrence: 'Datum des Auftretens',
    application_policy_name: 'Name der Anwendungsrichtlinie',
    beneficiary_type: 'Art des Begünstigten',
    benefactor_type: 'Wohltätertyp',
    target_amount: 'Zielbetrag',
    principal_amount: 'Nennbetrag',
    allowance: 'Zulage',
    allowance_assets: 'Wertberichtigungsvermögen',
    allowance_amount: 'Zulassungsbetrag',
    affiliate_log: 'Aufschlüsselung der Zulagen',
    allowance_settlement: 'Zulassungsabrechnung',
    allowance_settlement_info: 'Informationen zur Abrechnung von Zulagen',
    name_asset_settled: 'Name des zu begleichenden Vermögens',
    balance_receive_payment: 'Restbetrag zu zahlen',
    select_account_settled:
      'Wählen Sie das Konto aus, das abgerechnet werden soll',
    no_affiliate_log: 'Es fällt keine Zulage an.',
    no_affiliate_balance:
      'Es gibt keine Liste der Wertberichtigungen nach Vermögenswerten.',
    no_affiliate_adjust: 'Es gibt keine Zulassungszahlungshistorie.',
    asset_name: 'Asset-Name',
    asset_code: 'Asset-Code',
    balance: 'Balance',
    cumulative_amount: 'Kumulierter Betrag',
    please_select_account: 'Bitte wählen Sie ein Konto',
    calculate: 'Berechnung',
    settle: 'Beruhige dich',
    calculate_amount: 'Abrechnungsbetrag',
    account_number: 'Accountnummer',
    registration_date: 'Registrierungsdatum',
    number: 'Nummer',
  },
  coin_name: 'Münzname',
  main_function: 'Hauptfunktion',
  disclosure_ing: 'Während der Arbeit',
  quick_service: 'Schnelldienste',
  new_account: 'Neues Konto',
  social_login: 'Social-Anmelden',
  way_to_find: 'Suche nach',
  cocobank_korea_head_office: 'COCOBANK Korea Hauptsitz',
  cocobank_branch_office: 'COCOBANK Shinsa Niederlassung',
  address_head_office: '528 Eonju-ro, Gangnam-gu, Seoul',
  address_branch_office: '803 Nonhyeon-ro, Gangnam-gu, Seoul',
  korean_language_counseling: 'Koreanische Beratung',
  hours_of_business: 'Korea von 10:00 bis 19:00 (ohne Bankfeiertage)',
  overseas_consultation: 'Überseeische Beratung',
  email_consultation: 'E-Mail-Beratung',
  exchange_price: 'Wechselkurs/Preis',
  market_price_check: 'Marktpreisüberprüfung',
  full_account_inquiry: 'Gesamtrechnung',
  exchange_details_check: 'Umrechnungseinstellung',
  cryptocurrency_exchange_history: 'Wechselkursverlauf',
  deposit_account_inquiry: 'Fondskonto-Überprüfung',
  transfer_result_check: 'Überprüfung der Transportergebnisse',
  dormant_account_check: 'Trefferkonto-Überprüfung',
  account_and_other_case_status:
    'Überprüfen Sie den Status des COCOBANK-Kontos und anderer Fälle.',
  account_and_other_wallet: 'Cuenta COCOBANK y otra consulta de billetera',
  account_search: 'COCOBANK Kontosuche',
  other_wallet_search: 'andere Brieftasche Transfer',
  error_remittance:
    'Einverständnis zur Rückgabe von Fehlersendungen innerhalb der Kokosbank',
  transfer: 'Umzug machen',
  other_wallets_transfer:
    'Andere Brieftaschen/Verlagerungsergebnisse überprüfen',
  other_wallets_transfer_search: 'Lookups von anderen Geldbörsenübertragungen',
  frequently_used_accounts:
    'Registrierung/Verwaltung von häufig verwendeten Konten',
  new_demand_account: 'Neue Nachfrage-Konto',
  new_installment_savings_account: 'Neues Konto',
  new_deposit_account: 'Neues Zeitkonto',
  check_account_progress_account: 'Überprüfen Sie den Status des neuen Kontos',
  download: 'herunterladen',
  withdrawal: 'Abzug',
  Smart_window_withdrawal: 'Smart-Fenster-Abzug',
  smart_ATM_withdrawal: 'Smart-ATM-Abzug',
  customer_service: 'Kundendienst',
  notice: 'Benachrichtigungen',
  one_one_inquiry: 'Trennung 1:1',
  inquiry_details: 'Abfragedetails',
  frequently_asked_questions: 'Frequently Asked Questions',
  server_notice: 'Server-Benachrichten',

  service_hours: 'Kundenzufriedenheit Service Öffnungszeiten',
  all_day_long: '(24 Stunden Anfrage)',
  online_service_hours: 'Online-Kocobank-Nutzungszeit',
  unusable_hours:
    '24 Stunden am Tag, 7 Tage die Woche (23: 30-24: 00 nicht verfügbar)',
  offline_hours: 'Öffnungszeiten der Offline-Bank',
  offline_bank_hours: '(außer an Wochenenden und Feiertagen)',

  management: 'Verwaltung',
  secure_management: 'Sicherheitszertifizierung/Verwaltung',
  fund_limit_management: 'Fondsbegrenzungsverwaltung',
  issue_details_check: 'Ausgabe-Inhaltungen',
  part_of_news: 'Dies ist der Teil der Nachrichten.',
  part_of_notice: 'Dies ist der Teil der Ankündigung.',
  full_menu: 'Volles Menü',
  individual: 'Individuell',
  key_coin:
    'Die Schlüsselmünze der COCOBANK, die Kryptowährung mit realer Währung verbindet',
  limitation_info:
    'Informationen zu Grenzwertbeschränkungen zur Verhinderung von Schäden durch Finanzbetrug in der Telekommunikation',
  limitation_info_1:
    'Da ein Sichtzahlungskonto nicht von Angesicht zu Angesicht eröffnet wird, ist das Limit für die Auszahlung (Überweisung) über automatisierte Geräte und das Internet auf {0} CCF pro Tag begrenzt.',
  limitation_info_2:
    'Objektive Authentifizierungsdaten zur Bestätigung des Transaktionszwecks können der Zweigstelle vorgelegt werden, und das Limit kann unter „Verwaltung > Sicherheitsauthentifizierung / -verwaltung“ aufgehoben werden.',
  limitation_info_3:
    'Wenn Sie Internetbanking verwenden, müssen Sie sich bei einem Auszahlungskonto registrieren, um eine Überweisungstransaktion durchzuführen.',
  limitation_info_4:
    'Pro Kryptowährungslimit können nur 5 Konten eröffnet werden.',
  limitation_notice: 'Beachten',
  limitation_notice_1:
    'Das Internetbanking-Abonnement kann durch Verknüpfen des Abschlussbildschirms nach Eröffnung eines Ein- und Auszahlungskontos beantragt werden.',
  limitation_notice_2:
    'Bitte beachten Sie, dass bestehende Internetbanking-Kunden sich nur dann über Internetbanking für Auszahlungskonten registrieren können, wenn die Registrierungskategorie für Auszahlungskonten Internet + Filiale ist.',
  limitation_notice_3:
    'Sie müssen sichere Authentifizierung sein, um sicherzustellen, dass Sie einfacher sind, um Ihren Transfer zum Internet-Banking durchzuführen. Nach dem Zertifizierungsprozess verbessern Sie bitte die Bewertung und fahren Sie mit der Buchhaltung und Anordnung des Rechnungslegungssystems fort.',
  new_subscription: 'Neue Registrierung',
  new_subscription1_1:
    'Wenn Sie auf die neue Anmeldeschaltfläche klicken, erhalten Sie Ihr eigenes',
  new_subscription1_2:
    'COCOBANK-Konto und Ihre Einzahlungsadresse, die mit der externen Geldbörse verknüpft sind.',
  new_subscription2_1:
    'Informieren Sie sich unbedingt vor der Einzahlung! Es fallen keine Gebühren an, wenn Sie Geld von einem COCOBANK-Konto auf Ihr Konto überweisen. Nur ',
  new_subscription2_2:
    'kann auf das Konto / die Adresse eingezahlt werden, die bei der Neuanmeldung ausgestellt wurde. Alle Fehler / Verluste, die auftreten können, wenn Sie versuchen, andere digitale Assets an die Adresse zu überweisen, können nicht behoben werden. Nachdem 1 Bestätigung erfolgt ist, wird diese durch den Einzahlungsprozess im Saldo ausgewiesen. Der Einzahlungsprozess erfolgt automatisch und die erforderliche Zeit kann je nach Netzwerkbedingungen variieren. Die oben angegebene Adresse dient nur zur Anzahlung.',
  new_subscription3_1: 'Sie können ',
  new_subscription3_2:
    ' für neue Abonnements hinterlegen, die Ihnen zugewiesen wurden.',
  new_subscription4:
    'Haben Sie dem oben Gesagten zugestimmt und es verstanden?',

  created_account_number: 'Kontonummer erstellt',
  cocobank_exclusive_account: 'Exklusive COCOBANK-Kontonummer',
  depositing_external_wallet:
    'Bei der Einzahlung von COCOBANK aus einer externen Geldbörse',
  use: 'Benutzen',
  we_future: 'unsere Zukunft',
  pop_cocobank: 'COCOBANK',
  fourth_industry: 'Führend in der vierten Branche',
  oc_15: '15. Oktober',
  officially_open: 'Offiziell eröffnet!',
  head_branch_office:
    'Hauptsitz Korea (Zweigstelle Jamsil) / 1. Zweigstelle (Zweigstelle Sinsa)',
  sep_15: '15. September um 17 Uhr',
  open_popup: 'öffnen',
  thanks_for: 'Danke für deine Ermutigung.',

  direct_exchange: {
    sell_buy_assets: 'Zu verkaufende und zu kaufende Vermögenswerte',
    replace_assets: 'Zu ersetzender Vermögenswert',
    ccm_exchange_rate: 'CCM hält bevorzugten Wechselkurs',
    buy_sell_percent: 'Kaufen -10% Verkaufen + 10%',
    expected_property: 'Erwartetes Eigentum',
    preferential_property: 'Bevorzugte Vermögenswerte',
  },

  event_banner: {
    clap:
      'Bewahren Sie die Verschlüsselungsgelder in <span class="color-common">CLAP</span> von der COCO BANK.',
    month_hotcoupon: 'Schauen Sie sich den HEISSEN Gutschein dieses Monats an.',
    hotcoupon_sub:
      'Von Wechselkursen bis zu verschiedenen Affiliate-Gutscheinen!',
    grab_bug: 'Fang den Fehler',
    grab_bug_sub:
      'Bitte hinterlassen Sie eine 1: 1 Anfrage. Preise werden durch Lotterie vergeben.',
    event2_sub_title: 'Höhere Raten.<br>Noch höhere Renditen.',
    event2_title: '',
    event2_text: 'Werden Sie Mitglied des CCM und erhalten Sie eine Dividende!',
    event2_btn: 'Anmelden',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: 'schließen',
    notice_today: 'Heute nicht sehen',
  },
  clap: {
    getting_started_clap: 'Grundeinstellungsmethode',
    how_to_initialize_clap: 'Zurücksetzen',
    getting_started_ledger_live: 'So richten Sie Ledger Live ein',
    install_coin_app: 'Münz-App-Verknüpfung',
    start_text_1:
      '1. Überprüfen Sie nach dem Anschließen des CLAP und des beiliegenden USB-Anschlusses an den Computer den Ausdruck "Willkommen", um zu bestätigen, dass es sich um ein neues Produkt handelt.',
    start_text_2:
      '2. Drücken Sie die rechte Taste. Wenn die Meldung "Als neues Gerät einrichten" angezeigt wird, drücken Sie gleichzeitig die beiden oberen Tasten.',
    start_text_3:
      '3. Nach Bestätigung des Ausdrucks „PIN-Code auswählen“ wird ein Bildschirm zur Eingabe eines 8-stelligen PIN-Codes angezeigt. Drücken Sie beide Tasten, um den PIN-Code einzustellen.',
    start_text_4:
      '4. Wenn die Einstellung des PIN-Codes abgeschlossen ist, wird die Meldung PIN-Code bestätigen angezeigt. Geben Sie den PIN-Code erneut ein, indem Sie beide Tasten drücken.',
    start_text_5:
      '5. Wenn die Einstellung des PIN-Codes abgeschlossen ist, drücken Sie die rechte Taste, um die erste von 24 Phrasen anzuzeigen. Schreiben Sie den Code entsprechend der Nummer auf dem Bildschirm auf die Rückseite der wichtigen Wiederherstellungskarte.',
    start_text_6:
      '6. Geben Sie nach Abschluss des Schreibvorgangs die Wiederherstellungscodes 1 bis 24 ein, die nacheinander mit den Zahlen übereinstimmen.',
    start_text_7:
      '7. Wenn die Meldung Beide Tasten drücken, um fortzufahren angezeigt wird, drücken Sie beide Tasten oben, um fortzufahren.',
    init_text_1:
      '1. Überprüfen Sie vor der Initialisierung zunächst, ob Sie über eine wichtige Wiederherstellungskarte und einen Wiederherstellungscode verfügen.',
    init_text_2:
      '2. Es gibt zwei Möglichkeiten zum Initialisieren. Wenn CLAP an den PC angeschlossen ist und der PIN-Code dreimal hintereinander falsch ist, wird er automatisch initialisiert.',
    init_text_3:
      '3. Schließen Sie zweitens den CLAP an den PC an und geben Sie den zu entsperrenden PIN-Code ein. Gehen Sie dann der Reihe nach zu Einstellungen> Sicherheit> Alle zurücksetzen.',
    init_text_4:
      '4. Drücken Sie erneut auf Alle zurücksetzen unter Abbrechen und Alle zurücksetzen, um mit der Initialisierung fortzufahren.',
    init_text_5:
      '5. Geben Sie den PIN-Code ein, um die Initialisierung abzuschließen.',
    init_text_6: '6. Die Initialisierung ist abgeschlossen.',
    ledger_live_text_1:
      '1. Geben Sie start.ledgerwallet.com in die Internetadressleiste ein.',
    ledger_live_text_2:
      '2. Klicken Sie in Schritt 1 auf die Ledger Live-App, um die App für Ihr Handy oder Ihren PC zu installieren.',
    ledger_live_text_3:
      '3. Wenn die Meldung Willkommen bei Ledger Live angezeigt wird, klicken Sie auf Erste Schritte, um fortzufahren.',
    ledger_live_text_4:
      '4. Sie erhalten 4 Optionen. Wenn Sie einen neuen CLAP kaufen und damit fortfahren, können Sie Nr. 1 auswählen und die anderen können entsprechend Ihrer Situation ausgewählt werden.',
    ledger_live_text_5:
      '5. Drücken Sie 3, wenn die Grundeinstellung abgeschlossen ist, um fortzufahren.',
    ledger_live_text_6:
      '6. Wählen Sie das Ledger Nano S aus den drei Optionen aus und klicken Sie auf Weiter.',
    ledger_live_text_7:
      '7. Es gibt drei Checklisten. Bitte stellen Sie es entsprechend Ihrer aktuellen Situation ein.',
    ledger_live_text_8:
      '8. Klicken Sie nach dem Überprüfen der Checkliste auf den dritten Check Now.',
    ledger_live_text_9:
      '9. Schließen Sie den CLAP an den Computer an und entsperren Sie den CLAP. (Dies ist der Authentifizierungsprüfungsprozess.)',
    ledger_live_text_10:
      '10. Wenn Ihr Gerät in der dritten Checkliste echt ist, klicken Sie unten rechts auf Weiter.',
    ledger_live_text_11:
      '11. Die Seite zur Kennworteinstellung wird angezeigt. Sie können ein Passwort festlegen oder nicht. Wenn Sie ein Passwort festlegen möchten, klicken Sie unten rechts nach der Eingabe auf Weiter / Überspringen dieses Schritts.',
    ledger_live_text_12:
      '12. Klicken Sie unten rechts auf Weiter, um fortzufahren.',
    ledger_live_text_13:
      '13. Die Einstellung von Ledger Live ist abgeschlossen.',
    coin_app_text_1:
      '1. Aktivieren Sie das zuvor installierte Ledger Live und klicken Sie in der Mitte auf Gehe zu Manager.',
    coin_app_text_2:
      '2. Verbinden Sie CLAP mit dem PC und geben Sie den PIN-Code ein',
    coin_app_text_3:
      '3. Wenn Sie den PIN-Code eingegeben haben, drücken Sie beide oberen Tasten gleichzeitig, um fortzufahren.',
    coin_app_text_4:
      '4. Suchen Sie die Kryptowährung, die Sie unten haben, und klicken Sie rechts auf Installieren, um einen Link zu erstellen.',
    detail_to_buy: 'Details und Ort des Kaufs',
    detail_content1_1:
      'Clap ist ein Sinn, dass das Verschlüsselungsportfolio des Benutzers konfiguriert ist, um sicherzustellen, dass der Vermögenswert sicher aufrechterhalten wird.',
    detail_content1_2:
      'Die globale Finanzbranche bewegt sich rasch durch die Entdeckung und Innovation neuer Technologien. Cryptures änderte sich ebenfalls und beantragten sich entsprechend diesen Änderungen, und viele globale Unternehmen haben wieder auf den Wert des Krypto aufmerksam gemacht.',
    detail_content1_3:
      'Langfristige Benutzer haben aufgrund der Art der Verschlüsselung mehr Probleme mit der Sicherheit von Vermögenswerten, die nur in Form von Informationen auf einem Computer verwendet werden.',
    detail_title_2: 'Der von Clap bereitgestellte Dienst ist sicher.',
    detail_content2_1:
      'Die Coco Bank beurteilte, dass eine Softwallte, die private Schlüssel in der Cloud speichert, anfällig für externe Hacks ist, und ein Sicherheitsproblem tritt auf. Wir empfehlen, die Lösungsbrieftasche zu lösen, die diese Probleme ergänzt.',
    detail_content2_2:
      'Clap unterstützt bis zu acht Anwendungen und kann eine Vielzahl von Verschlüsseln wie Bitmünzen, Stirn und Gerbereien behalten. Sie können auch Vermögenswerte sicher von externen Hacks aufbewahren, da es keine Brieftasche ist, die nicht immer mit dem Internet verbunden ist.',
    detail_title_3: 'Sicherheit',
    detail_content3_1:
      'Clap ist eine Zusammenarbeit (Cold-Wallet), eine Zusammenarbeit mit "Ledger" und Collaboration mit einem globalen Encryption Professional Security Solution Company, um die Sicherheitsprobleme einer Hot-Wall (Hot-Wallet) zu lösen.',
    detail_content3_2:
      'Die Klatsche wurde von einer Sicherheitslösung angewendet, die von 130 globalen Ingenieuren mit digitalem Sicherheitskenntnissen und Erfahrung errichtet wurde. Wir haben die neuesten Sicherheits-PIN-Code-Chips eingefügt, die von Pässen und Kreditkarten verwendet werden, um die Sicherheit zu verbessern.',
    detail_content3_3:
      'Selbst wenn Sie klatschen, können Sie die Vermögenswerte behalten, die Sie vom Benutzer über das neue Clac-Gerät besitzen.',
    detail_title_4: 'Bequemlichkeit',
    detail_content4_1:
      'Sie können den geheimen Schlüssel mit zwei Tasten an der Spitze der Klatsche eingeben.',
    detail_content4_2:
      'Wir unterstützten mehr als 40 Verschlüsse, einschließlich Bitcoin, Ethereum und XRP, und berücksichtigen der Benutzerkomfort.',
    detail_title_6: 'WIE',
    detail_content6_1: 'A / S für Produktgeräte ist ein Jahr ab Kaufdatum.',
    detail_content6_2:
      'Wenn A / S erforderlich ist, besuchen Sie bitte die Coco Bank mit dem Klappkörper.',
    detail_content6_3:
      'Eine an der Rückseite des Klammerns für A / S angehängte Seriennummer ist erforderlich. A / S kann nicht verwendet werden, um die Seriennummer zu unterminieren oder zu entfernen.',
    detail_content6_4:
      'A / S ist möglicherweise nicht möglich, abhängig von dem Produkt des Produkts, das durch Ihre Nachlässigkeit und den Zustand des Produkts verursacht wird.',
    detail_title_7: 'Beachten',
    detail_content7_1:
      'Claps Online-Dienste sind nicht mit der Coco Bank verbunden, da sie von Ledger serviert werden.',
    detail_content7_2:
      'Wenn Sie das Produkt verwenden, beachten Sie bitte, dass das Problem des Hackens von außen, das durch das externe Hacking-Problem verursacht wird, das durch die achtsame (Verlust, Wiederherstellung und Anschließen des PIN-Codes an den infizierten PC verursacht wird) nicht für die Coco Bank verantwortlich ist.',
    detail_content7_3:
      'Online-Dienste, die von "Ledger Live" oder Ledger bereitgestellt werden, sind für das Geld, das der vom Benutzer erhaltene vom Benutzer erhaltene Benutzer für die Coco Bank irrelevant ist, irrelevant.',
    detail_title_8: 'Kauf',
    detail_content8_1: 'Co.u co.u (Cafe): 430 1. Stock',
    detail_title_9: 'A / S-Empfang',
    detail_content9_1: 'Coco Bank: Seoul, Gangnam-Gu, Seoul 528 2. Etage',
    detail_content9_2:
      'Bitte zögern Sie nicht, uns mit dem nächsten Kozuko KOH oder help@cocobank.com zu kontaktieren.',
  },
}
